import { jsx as o, jsxs as h, Fragment as te } from "react/jsx-runtime";
import _, { useState as H, Children as Zr, useRef as L, useEffect as U, useLayoutEffect as en, forwardRef as br, Fragment as ae, isValidElement as tn, cloneElement as rn, createElement as nn, createContext as ue, useContext as ie, useReducer as Je, createRef as Ye, useCallback as Re, useMemo as j } from "react";
import { g as $t, a as ln, t as T, c as Lt, u as Ze, b as Pt, d as on, k as an } from "./useMobile-11908957.mjs";
import { T as As } from "./useMobile-11908957.mjs";
import x, { clsx as sn } from "clsx";
import { D as cn, t as Ne, S as et, a as He, b as tt, c as un, d as gr, e as hr, f as dn, g as pn, h as Ft, i as rt, j as vr, k as mn, l as fn, m as bn, n as gn, o as hn, p as xr, q as vn, r as xn, s as yn, u as wn, v as Nn, w as Sn, x as On, y as Tn, z as In, A as yr, B as kn, C as Cn, E as Rn, F as En } from "./index-fafba757.mjs";
import { NavLink as wr, Link as Ie, useLocation as $n } from "react-router-dom";
import Nr from "react-modal";
import Ln from "react-textarea-autosize";
import { SwipeableList as Pn, SwipeableListItem as Fn, Type as Dn, LeadingActions as An, TrailingActions as Mn, SwipeAction as _n } from "react-swipeable-list";
import "react-swipeable-list/dist/styles.css";
const jn = ({
  id: e,
  name: t,
  inline: r,
  bgColor: n,
  isHoverable: l
}) => /* @__PURE__ */ o(
  nt,
  {
    className: x($t(e)),
    id: e,
    inline: r,
    isHoverable: l,
    tooltip: t,
    children: /* @__PURE__ */ o(
      "div",
      {
        className: "flex h-8 min-h-8 w-8 min-w-8 items-center justify-center",
        style: { backgroundColor: n ? `${n}` : "" },
        children: /* @__PURE__ */ o(cn, { className: "h-5 w-5 fill-grey-06 text-grey-04 mix-blend-screen" })
      }
    )
  }
), Dt = ({
  id: e,
  name: t,
  imageSrc: r,
  inline: n = !1,
  isHoverable: l,
  bgColor: i
}) => /* @__PURE__ */ o(
  nt,
  {
    className: x($t(e, t), "text-white"),
    id: e,
    tooltip: t,
    inline: n,
    isHoverable: l,
    children: /* @__PURE__ */ o(
      "div",
      {
        className: "flex h-8 min-h-8 w-8 min-w-8 items-center justify-center",
        style: { backgroundColor: i ? `${i}` : "" },
        children: /* @__PURE__ */ o(Sr, { src: r, alt: t })
      }
    )
  }
), es = ({
  name: e,
  imageSrc: t,
  isHoverable: r,
  objectContain: n
}) => /* @__PURE__ */ o(nt, { isRound: !1, isHoverable: r, tooltip: e, children: /* @__PURE__ */ o("div", { className: "h-full w-full", children: /* @__PURE__ */ o(
  Sr,
  {
    src: t,
    alt: e,
    objectContain: n
  }
) }) }), Bn = ({
  content: e,
  tooltip: t,
  isHoverable: r
}) => /* @__PURE__ */ o(
  nt,
  {
    className: x(" bg-grey-02 text-black"),
    isHoverable: r,
    tooltip: t,
    children: /* @__PURE__ */ o("span", { className: "", children: e })
  }
), Sr = ({
  src: e,
  alt: t,
  objectContain: r
}) => {
  const [n, l] = H(!1);
  return e && !n ? /* @__PURE__ */ o(
    "img",
    {
      className: `${r ? "object-contain" : "object-cover"} h-full`,
      src: e,
      onError: () => l(!0),
      alt: t
    }
  ) : /* @__PURE__ */ o("span", { className: "", children: ln(t || "A") });
}, nt = ({
  className: e,
  children: t,
  inline: r = !1,
  isRound: n = !0,
  isHoverable: l = !1,
  tooltip: i
}) => /* @__PURE__ */ o(
  "div",
  {
    className: x([
      r ? "mr-3 inline-flex" : "flex flex-none",
      "items-center justify-center",
      "text-xs font-semibold leading-6",
      "h-8 min-h-8 w-8 min-w-8 overflow-hidden after:absolute after:h-8 after:w-8",
      "after:opacity-[.16] after:content-['']",
      l ? "hover:after:bg-black" : "",
      n ? "rounded-full after:rounded-full" : "rounded-lg after:rounded-lg",
      e
    ]),
    title: i,
    children: t
  }
), At = 3, Hn = (e) => e.slice(At, e.length).map((t) => t == null ? void 0 : t.props.name).join(`
`), Gn = (e) => `+${e.length - At}`, Vn = ({
  children: e,
  maxAvatars: t = At,
  onClick: r
}) => /* @__PURE__ */ h("div", { className: "ml-2 flex", onClick: r, role: r ? "button" : "", children: [
  e.slice(0, t).map((n, l) => /* @__PURE__ */ o(
    "div",
    {
      className: "relative -ml-2 rounded-full border-2 border-solid border-white",
      children: n
    },
    l
  )),
  e.length > t ? /* @__PURE__ */ o("div", { className: "relative -ml-2 rounded-full border-2 border-solid border-white", children: /* @__PURE__ */ o(
    Bn,
    {
      content: Gn(e),
      tooltip: Hn(e)
    }
  ) }) : /* @__PURE__ */ o(te, {})
] }), ts = ({
  children: e,
  title: t
}) => /* @__PURE__ */ h("div", { className: "relative p-8 text-left", children: [
  /* @__PURE__ */ o("h3", { className: "heading-xl mb-4", children: t }),
  /* @__PURE__ */ o("div", { className: "text-sm-multiline relative z-20 max-w-[532px] text-grey-06", children: e }),
  /* @__PURE__ */ o(
    "div",
    {
      className: "absolute right-0 bottom-0 z-10 flex max-w-[512px] flex-row-reverse flex-wrap-reverse",
      role: "img",
      children: Array.from(Array(15)).map((r, n) => /* @__PURE__ */ o(
        Un,
        {
          className: n === 13 ? "fill-grey-02" : "fill-grey-01"
        },
        n
      ))
    }
  )
] }), Un = ({ className: e }) => /* @__PURE__ */ o(
  "svg",
  {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    className: e,
    children: /* @__PURE__ */ o("path", { d: "M64 0L35.3284 0.0482291L0 35.3519V64H28.6241L64 28.6963V0Z" })
  }
), zn = ({
  children: e
}) => /* @__PURE__ */ o("nav", { children: /* @__PURE__ */ o("ul", { className: "block", children: e }) }), Kn = ({
  children: e,
  to: t
}) => /* @__PURE__ */ o(
  "li",
  {
    className: x(
      "inline after:mx-2 after:text-grey-04 after:content-['/']",
      "text-grey-05 last:text-black last:after:content-none"
    ),
    children: /* @__PURE__ */ o(wr, { to: t, className: "text-sm hover:text-grey-08 active:text-black", children: e })
  }
);
zn.Item = Kn;
const qn = {
  "dark-outline": "shadow-[inset_0_0_0_1px] disabled:shadow-none shadow-grey-03 text-white disabled:text-grey-07 bg-transparent disabled:bg-grey-08 hover:bg-grey-transparent-dark-01 active:bg-grey-transparent-dark-02 focus-visible:outline-primary-02/50",
  destruct: "bg-error-04 text-white hover:bg-error-05 active:bg-error-06 focus-visible:outline-error-02",
  ghost: "bg-transparent hover:bg-grey-transparent-01 active:bg-grey-transparent-02 focus-visible:outline-primary-02",
  outline: "shadow-[inset_0_0_0_1px] disabled:shadow-none shadow-grey-03 hover:bg-grey-transparent-01 active:bg-grey-transparent-02 focus-visible:outline-primary-02",
  primary: "bg-primary-04 hover:bg-primary-05 active:bg-primary-06 focus-visible:outline-primary-02",
  secondary: "bg-grey-01 hover:bg-grey-02 active:bg-primary-03 focus-visible:outline-primary-02",
  text: "font-normal hover:underline disabled:hover:no-underline active:bg-grey-transparent-01 disabled:text-grey-03 disabled:bg-transparent focus-visible:outline-primary-02/50",
  warning: "shadow-[inset_0_0_0_1px] disabled:shadow-none shadow-grey-03 text-error-04 hover:bg-grey-transparent-01 active:bg-grey-transparent-02 focus-visible:outline-primary-02"
}, Wn = {
  lg: "text-md px-4 py-2",
  md: "text-sm px-4 py-2",
  sm: "text-sm px-3 py-1"
}, Xn = {
  lg: "p-2",
  md: "p-2",
  sm: "p-1"
}, Qn = {
  lg: "",
  md: "py-1.5 px-2 text-sm",
  sm: "py-1.5 px-2 text-xs"
}, Oe = ({
  className: e,
  containsOnlyIcon: t = !1,
  size: r = "md",
  variant: n = "primary",
  children: l,
  ...i
}) => {
  const a = t ? Xn[r] : Wn[r], s = x([
    "font-medium min-w-max rounded-md text-center",
    "transition-colors duration-200 ease-out",
    "focus-visible:outline focus-visible:outline-4",
    "disabled:bg-grey-02 disabled:text-grey-04",
    n !== "warning" && "text-grey-09",
    n === "text" ? Qn[r] : a,
    qn[n],
    e
  ]);
  return typeof l == "function" ? /* @__PURE__ */ o(te, { children: l({ className: s }) }) : /* @__PURE__ */ o("button", { className: s, type: "button", ...i, children: l });
}, Tt = ({
  children: e,
  size: t,
  variant: r,
  className: n,
  ...l
}) => /* @__PURE__ */ o(Oe, { size: t, variant: r, children: ({ className: i }) => /* @__PURE__ */ o(
  Ie,
  {
    className: Ne(x("block", n, i)),
    ...l,
    children: e
  }
) }), me = ({
  children: e,
  className: t,
  onClick: r
}) => /* @__PURE__ */ o("div", { className: t, onClick: r, children: e }), Yn = ({ children: e, bottomMargin: t = "sm", customStyles: r }) => /* @__PURE__ */ o(
  "h3",
  {
    className: x([
      "text-base-semibold break-all",
      t === "xs" && "mb-0.5",
      t === "sm" && "mb-2",
      t === "lg" && "mb-3",
      r
    ]),
    children: e
  }
), Jn = ({
  children: e,
  className: t
}) => /* @__PURE__ */ o("p", { className: Ne("break-all text-left text-sm text-grey-07", t), children: e }), Zn = {
  outline: T`bg-white hover:bg-grey-transparent-01 active:bg-grey-transparent-02 border border-solid border-grey-03`,
  solid: T`bg-grey-02 hover:bg-grey-03 active:bg-grey-04`
}, el = ({ children: e, variant: t = "solid", onClick: r, disabled: n = !1 }) => /* @__PURE__ */ o(
  "button",
  {
    onClick: r,
    className: x([
      "rounded-2xl py-1.5 px-4 text-sm",
      n ? "bg-grey-02" : Zn[t]
    ]),
    disabled: n,
    children: e
  }
);
me.Title = Yn;
me.Body = Jn;
me.Button = el;
const Ge = ({
  ariaLabel: e,
  children: t,
  checked: r = !1,
  className: n,
  disabled: l = !1,
  id: i,
  name: a,
  onChange: s
}) => {
  const c = x([
    "relative block h-5 w-5",
    "bg-transparent transition-colors",
    "border-2 border-grey-06 !ring-transparent",
    "focus-visible:outline-offset-0 focus-visible:outline-secondary-02",
    !r && !l && "hover:bg-secondary-01",
    !l && "checked:bg-secondary-04 checked:hover:bg-secondary-03",
    l && "checked:bg-grey-02 checked:hover:bg-grey-02",
    l ? "cursor-not-allowed border-grey-02" : "cursor-pointer border-grey-06",
    n
  ]);
  if (typeof t == "function") {
    const u = Ne(
      x(
        c,
        "rounded-full",
        r && "bg-secondary-04 hover:bg-secondary-03 border-transparent",
        r && "radio-checked"
      )
    );
    return /* @__PURE__ */ o(te, { children: t({ className: u }) });
  }
  return /* @__PURE__ */ o(
    "input",
    {
      "aria-checked": r,
      "aria-label": e,
      checked: r,
      className: c,
      disabled: l,
      id: i,
      name: a,
      onChange: s ? (u) => {
        s(u.currentTarget.checked);
      } : void 0,
      readOnly: s ? void 0 : !0,
      type: "radio"
    }
  );
}, tl = ({
  Illustration: e,
  children: t,
  goToButtonLabel: r,
  goToButtonLink: n = "",
  illustrationBackgroundClassName: l = "bg-grey-01",
  index: i = 0,
  nextButtonLabel: a,
  previousButtonLabel: s,
  setActiveStep: c,
  skipButtonClick: u,
  skipButtonLabel: p,
  totalSteps: d = 0,
  title: m
}) => {
  const f = L(null), b = Ze();
  U(() => {
    const v = new window.IntersectionObserver(
      (M) => {
        M[0].isIntersecting && (c == null || c(i));
      },
      {
        root: document.querySelector("#carousel-container"),
        threshold: 1
      }
    );
    f.current && v.observe(f.current);
  }, [f]);
  const g = b ? "smooth" : "auto", y = () => {
    var v;
    (v = document.getElementById(`carousel-step-${i + 1}`)) == null || v.scrollIntoView({ behavior: g });
  }, w = () => {
    var v;
    (v = document.getElementById(`carousel-step-${i - 1}`)) == null || v.scrollIntoView({ behavior: g });
  };
  return /* @__PURE__ */ h(
    "div",
    {
      id: `carousel-step-${i}`,
      ref: f,
      className: "flex w-screen min-w-full snap-start flex-col gap-6 overflow-hidden px-10 sm:flex-row-reverse sm:items-center sm:px-0",
      children: [
        /* @__PURE__ */ o(
          "div",
          {
            className: x(
              "flex flex-none justify-center sm:h-screen sm:basis-1/2 sm:items-center",
              !b && l
            ),
            children: /* @__PURE__ */ o(e, { className: "aspect-square max-h-[20vh] sm:max-h-[40vh]" })
          }
        ),
        /* @__PURE__ */ h("div", { className: "flex flex-col gap-8 sm:basis-1/2 sm:items-center", children: [
          /* @__PURE__ */ o("h2", { className: "text-center text-xl font-semibold sm:max-w-[30vw] sm:text-3xl", children: m }),
          /* @__PURE__ */ o("p", { className: "text-base-multiline text-grey-07 sm:max-w-[30vw]", children: t }),
          /* @__PURE__ */ h("div", { className: "flex w-full flex-none gap-4 sm:max-w-[30vw]", children: [
            i === 0 && /* @__PURE__ */ o(
              Oe,
              {
                className: "hidden grow sm:block",
                variant: "outline",
                onClick: u,
                children: p
              }
            ),
            i > 0 && /* @__PURE__ */ o(
              Oe,
              {
                className: "hidden grow sm:block",
                variant: "outline",
                onClick: w,
                children: s
              }
            ),
            i < d - 1 && /* @__PURE__ */ o(Oe, { className: "hidden grow sm:block", onClick: y, children: a }),
            i + 1 === d && /* @__PURE__ */ o(Tt, { className: "grow", to: n, children: r })
          ] })
        ] })
      ]
    }
  );
}, rl = ({
  children: e,
  logoSrc: t,
  nextButtonLabel: r,
  previousButtonLabel: n,
  goToButtonLabel: l,
  goToButtonLink: i,
  skipButtonClick: a,
  skipButtonLabel: s
}) => {
  const [c, u] = H(0);
  return /* @__PURE__ */ h(
    "div",
    {
      id: "carousel-container",
      className: "flex h-screen max-h-screen w-screen flex-col items-start overflow-hidden pt-8 pb-10 sm:bg-white sm:py-0",
      children: [
        /* @__PURE__ */ o("div", { className: "flex w-full justify-center sm:fixed sm:left-6 sm:top-6 sm:w-auto", children: /* @__PURE__ */ o("img", { src: t, className: "mb-10 h-12 w-12 flex-none" }) }),
        /* @__PURE__ */ o("div", { className: "carousel flex w-screen snap-x snap-mandatory flex-row overflow-x-scroll sm:h-full", children: Lt(e, {
          goToButtonLabel: l,
          goToButtonLink: i,
          nextButtonLabel: r,
          previousButtonLabel: n,
          setActiveStep: u,
          skipButtonClick: a,
          skipButtonLabel: s,
          totalSteps: e.length
        }) }),
        /* @__PURE__ */ o("div", { className: "mt-9 flex w-full flex-none justify-center gap-4.5 sm:hidden", children: Zr.map(e, (p, d) => /* @__PURE__ */ o(Ge, { checked: d === c, children: ({ className: m }) => /* @__PURE__ */ o(
          "div",
          {
            className: Ne(
              x(m, "cursor-default hover:bg-inherit")
            )
          }
        ) }, d)) })
      ]
    }
  );
};
rl.Step = tl;
const Mt = ({
  ariaLabel: e,
  checked: t,
  className: r,
  disabled: n,
  id: l,
  indeterminate: i = !1,
  name: a,
  onChange: s
}) => {
  const c = L(null);
  return U(() => {
    c.current.indeterminate = i;
  }, [c, i]), /* @__PURE__ */ o(
    "input",
    {
      className: x(
        "h-5 w-5 rounded border-2 border-grey-06 bg-transparent",
        "!outline-2 !outline-offset-0 !outline-secondary-02",
        // !importants to override the tailwindcss-forms defaults
        "checked:bg-secondary-04 indeterminate:bg-secondary-04",
        "hover:border-grey-08 checked:hover:bg-secondary-05 indeterminate:hover:bg-secondary-05",
        "focus:!outline-0 focus:ring-0 focus:!ring-transparent focus-visible:!outline-2",
        "disabled:border-grey-03 disabled:bg-grey-02 checked:disabled:bg-grey-03 indeterminate:disabled:bg-grey-03",
        !n && "cursor-pointer",
        r
      ),
      ref: c,
      type: "checkbox",
      disabled: n,
      checked: t,
      id: l,
      name: a,
      onChange: s ? (u) => {
        s(i ? !1 : u.currentTarget.checked);
      } : void 0,
      "aria-checked": i ? "mixed" : t,
      "aria-label": e
    }
  );
}, Or = ({ disabled: e, children: t, id: r }) => /* @__PURE__ */ o(
  "label",
  {
    className: x(
      "ml-2 align-middle text-sm leading-5 text-grey-08",
      !e && "cursor-pointer"
    ),
    htmlFor: r,
    children: t
  }
), nl = ({
  children: e,
  disabled: t,
  className: r,
  ...n
}) => /* @__PURE__ */ h(
  "label",
  {
    className: x([
      "flex flex-1 items-center rounded-lg border border-grey-02 bg-white px-4.5 py-3.5",
      !t && "hover:border-grey-04",
      r
    ]),
    children: [
      /* @__PURE__ */ o(Mt, { ...n }),
      e && /* @__PURE__ */ o("div", { className: "ml-5 w-full", children: e })
    ]
  }
), ll = ({
  disabled: e,
  children: t,
  value: r,
  groupValue: n,
  className: l,
  onChange: i
}) => {
  const a = n ? n.includes(r) : !1;
  return /* @__PURE__ */ h("li", { children: [
    /* @__PURE__ */ o(
      Mt,
      {
        className: l,
        disabled: e,
        checked: a,
        id: r,
        onChange: () => i == null ? void 0 : i(r)
      }
    ),
    /* @__PURE__ */ o(Or, { disabled: e, id: r, children: t })
  ] });
}, ol = ({ disabled: e, children: t, value: r, groupValue: n, onChange: l, className: i }) => {
  const a = n ? n.includes(r) : !1;
  return /* @__PURE__ */ o("li", { children: /* @__PURE__ */ o(
    nl,
    {
      className: i,
      disabled: e,
      checked: a,
      id: r,
      onChange: () => l == null ? void 0 : l(r),
      children: t
    }
  ) });
}, Tr = ({ children: e, value: t, onChange: r, gap: n }) => {
  const l = (i) => {
    t.includes(i) ? r(t.filter((a) => a !== i)) : r([...t, i]);
  };
  return /* @__PURE__ */ o("ul", { className: x("flex flex-col", n || "gap-6"), children: Lt(e, {
    groupValue: t,
    onChange: l
  }) });
};
Tr.Option = ll;
Tr.CardOption = ol;
var al = Object.defineProperty, il = (e, t, r) => t in e ? al(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, bt = (e, t, r) => (il(e, typeof t != "symbol" ? t + "" : t, r), r);
let sl = class {
  constructor() {
    bt(this, "current", this.detect()), bt(this, "handoffState", "pending"), bt(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, $e = new sl(), z = (e, t) => {
  $e.isServer ? U(e, t) : en(e, t);
};
function be(e) {
  let t = L(e);
  return z(() => {
    t.current = e;
  }, [e]), t;
}
function Ve(e, t) {
  let [r, n] = H(e), l = be(e);
  return z(() => n(l.current), [l, n, ...t]), r;
}
function cl(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function ce() {
  let e = [], t = { addEventListener(r, n, l, i) {
    return r.addEventListener(n, l, i), t.add(() => r.removeEventListener(n, l, i));
  }, requestAnimationFrame(...r) {
    let n = requestAnimationFrame(...r);
    return t.add(() => cancelAnimationFrame(n));
  }, nextFrame(...r) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...r));
  }, setTimeout(...r) {
    let n = setTimeout(...r);
    return t.add(() => clearTimeout(n));
  }, microTask(...r) {
    let n = { current: !0 };
    return cl(() => {
      n.current && r[0]();
    }), t.add(() => {
      n.current = !1;
    });
  }, style(r, n, l) {
    let i = r.style.getPropertyValue(n);
    return Object.assign(r.style, { [n]: l }), this.add(() => {
      Object.assign(r.style, { [n]: i });
    });
  }, group(r) {
    let n = ce();
    return r(n), this.add(() => n.dispose());
  }, add(r) {
    return e.push(r), () => {
      let n = e.indexOf(r);
      if (n >= 0)
        for (let l of e.splice(n, 1))
          l();
    };
  }, dispose() {
    for (let r of e.splice(0))
      r();
  } };
  return t;
}
function de() {
  let [e] = H(ce);
  return U(() => () => e.dispose(), [e]), e;
}
let S = function(e) {
  let t = be(e);
  return _.useCallback((...r) => t.current(...r), [t]);
};
function _t() {
  let [e, t] = H($e.isHandoffComplete);
  return e && $e.isHandoffComplete === !1 && t(!1), U(() => {
    e !== !0 && t(!0);
  }, [e]), U(() => $e.handoff(), []), e;
}
var ir;
let oe = (ir = _.useId) != null ? ir : function() {
  let e = _t(), [t, r] = _.useState(e ? () => $e.nextId() : null);
  return z(() => {
    t === null && r($e.nextId());
  }, [t]), t != null ? "" + t : void 0;
};
function K(e, t, ...r) {
  if (e in t) {
    let l = t[e];
    return typeof l == "function" ? l(...r) : l;
  }
  let n = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((l) => `"${l}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(n, K), n;
}
function Ae(e) {
  return $e.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
let It = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Ee = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(Ee || {}), kt = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(kt || {}), ul = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(ul || {});
function Ir(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(It)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var lt = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(lt || {});
function ot(e, t = 0) {
  var r;
  return e === ((r = Ae(e)) == null ? void 0 : r.body) ? !1 : K(t, { [0]() {
    return e.matches(It);
  }, [1]() {
    let n = e;
    for (; n !== null; ) {
      if (n.matches(It))
        return !0;
      n = n.parentElement;
    }
    return !1;
  } });
}
function kr(e) {
  let t = Ae(e);
  ce().nextFrame(() => {
    t && !ot(t.activeElement, 0) && pl(e);
  });
}
var dl = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(dl || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function pl(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let ml = ["textarea", "input"].join(",");
function fl(e) {
  var t, r;
  return (r = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, ml)) != null ? r : !1;
}
function Ue(e, t = (r) => r) {
  return e.slice().sort((r, n) => {
    let l = t(r), i = t(n);
    if (l === null || i === null)
      return 0;
    let a = l.compareDocumentPosition(i);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function bl(e, t) {
  return Ct(Ir(), t, { relativeTo: e });
}
function Ct(e, t, { sorted: r = !0, relativeTo: n = null, skipElements: l = [] } = {}) {
  let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, a = Array.isArray(e) ? r ? Ue(e) : e : Ir(e);
  l.length > 0 && a.length > 1 && (a = a.filter((f) => !l.includes(f))), n = n ?? i.activeElement;
  let s = (() => {
    if (t & 5)
      return 1;
    if (t & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = (() => {
    if (t & 1)
      return 0;
    if (t & 2)
      return Math.max(0, a.indexOf(n)) - 1;
    if (t & 4)
      return Math.max(0, a.indexOf(n)) + 1;
    if (t & 8)
      return a.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = t & 32 ? { preventScroll: !0 } : {}, p = 0, d = a.length, m;
  do {
    if (p >= d || p + d <= 0)
      return 0;
    let f = c + p;
    if (t & 16)
      f = (f + d) % d;
    else {
      if (f < 0)
        return 3;
      if (f >= d)
        return 1;
    }
    m = a[f], m == null || m.focus(u), p += s;
  } while (m !== i.activeElement);
  return t & 6 && fl(m) && m.select(), 2;
}
function gt(e, t, r) {
  let n = be(t);
  U(() => {
    function l(i) {
      n.current(i);
    }
    return document.addEventListener(e, l, r), () => document.removeEventListener(e, l, r);
  }, [e, r]);
}
function jt(e, t, r = !0) {
  let n = L(!1);
  U(() => {
    requestAnimationFrame(() => {
      n.current = r;
    });
  }, [r]);
  function l(a, s) {
    if (!n.current || a.defaultPrevented)
      return;
    let c = function p(d) {
      return typeof d == "function" ? p(d()) : Array.isArray(d) || d instanceof Set ? d : [d];
    }(e), u = s(a);
    if (u !== null && u.getRootNode().contains(u)) {
      for (let p of c) {
        if (p === null)
          continue;
        let d = p instanceof HTMLElement ? p : p.current;
        if (d != null && d.contains(u) || a.composed && a.composedPath().includes(d))
          return;
      }
      return !ot(u, lt.Loose) && u.tabIndex !== -1 && a.preventDefault(), t(a, u);
    }
  }
  let i = L(null);
  gt("mousedown", (a) => {
    var s, c;
    n.current && (i.current = ((c = (s = a.composedPath) == null ? void 0 : s.call(a)) == null ? void 0 : c[0]) || a.target);
  }, !0), gt("click", (a) => {
    i.current && (l(a, () => i.current), i.current = null);
  }, !0), gt("blur", (a) => l(a, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function sr(e) {
  var t;
  if (e.type)
    return e.type;
  let r = (t = e.as) != null ? t : "button";
  if (typeof r == "string" && r.toLowerCase() === "button")
    return "button";
}
function at(e, t) {
  let [r, n] = H(() => sr(e));
  return z(() => {
    n(sr(e));
  }, [e.type, e.as]), z(() => {
    r || t.current && t.current instanceof HTMLButtonElement && !t.current.hasAttribute("type") && n("button");
  }, [r, t]), r;
}
let gl = Symbol();
function ee(...e) {
  let t = L(e);
  U(() => {
    t.current = e;
  }, [e]);
  let r = S((n) => {
    for (let l of t.current)
      l != null && (typeof l == "function" ? l(n) : l.current = n);
  });
  return e.every((n) => n == null || (n == null ? void 0 : n[gl])) ? void 0 : r;
}
function Bt({ container: e, accept: t, walk: r, enabled: n = !0 }) {
  let l = L(t), i = L(r);
  U(() => {
    l.current = t, i.current = r;
  }, [t, r]), z(() => {
    if (!e || !n)
      return;
    let a = Ae(e);
    if (!a)
      return;
    let s = l.current, c = i.current, u = Object.assign((d) => s(d), { acceptNode: s }), p = a.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, u, !1);
    for (; p.nextNode(); )
      c(p.currentNode);
  }, [e, n, l, i]);
}
function hl(e) {
  throw new Error("Unexpected object: " + e);
}
var A = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(A || {});
function Ht(e, t) {
  let r = t.resolveItems();
  if (r.length <= 0)
    return null;
  let n = t.resolveActiveIndex(), l = n ?? -1, i = (() => {
    switch (e.focus) {
      case 0:
        return r.findIndex((a) => !t.resolveDisabled(a));
      case 1: {
        let a = r.slice().reverse().findIndex((s, c, u) => l !== -1 && u.length - c - 1 >= l ? !1 : !t.resolveDisabled(s));
        return a === -1 ? a : r.length - 1 - a;
      }
      case 2:
        return r.findIndex((a, s) => s <= l ? !1 : !t.resolveDisabled(a));
      case 3: {
        let a = r.slice().reverse().findIndex((s) => !t.resolveDisabled(s));
        return a === -1 ? a : r.length - 1 - a;
      }
      case 4:
        return r.findIndex((a) => t.resolveId(a) === e.id);
      case 5:
        return null;
      default:
        hl(e);
    }
  })();
  return i === -1 ? n : i;
}
function Rt(...e) {
  return e.filter(Boolean).join(" ");
}
var Te = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Te || {}), we = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(we || {});
function W({ ourProps: e, theirProps: t, slot: r, defaultTag: n, features: l, visible: i = !0, name: a }) {
  let s = Cr(t, e);
  if (i)
    return Qe(s, r, n, a);
  let c = l ?? 0;
  if (c & 2) {
    let { static: u = !1, ...p } = s;
    if (u)
      return Qe(p, r, n, a);
  }
  if (c & 1) {
    let { unmount: u = !0, ...p } = s;
    return K(u ? 0 : 1, { [0]() {
      return null;
    }, [1]() {
      return Qe({ ...p, hidden: !0, style: { display: "none" } }, r, n, a);
    } });
  }
  return Qe(s, r, n, a);
}
function Qe(e, t = {}, r, n) {
  let { as: l = r, children: i, refName: a = "ref", ...s } = ht(e, ["unmount", "static"]), c = e.ref !== void 0 ? { [a]: e.ref } : {}, u = typeof i == "function" ? i(t) : i;
  "className" in s && s.className && typeof s.className == "function" && (s.className = s.className(t));
  let p = {};
  if (t) {
    let d = !1, m = [];
    for (let [f, b] of Object.entries(t))
      typeof b == "boolean" && (d = !0), b === !0 && m.push(f);
    d && (p["data-headlessui-state"] = m.join(" "));
  }
  if (l === ae && Object.keys(Fe(s)).length > 0) {
    if (!tn(u) || Array.isArray(u) && u.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${n} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(s).map((b) => `  - ${b}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((b) => `  - ${b}`).join(`
`)].join(`
`));
    let d = u.props, m = typeof (d == null ? void 0 : d.className) == "function" ? (...b) => Rt(d == null ? void 0 : d.className(...b), s.className) : Rt(d == null ? void 0 : d.className, s.className), f = m ? { className: m } : {};
    return rn(u, Object.assign({}, Cr(u.props, Fe(ht(s, ["ref"]))), p, c, vl(u.ref, c.ref), f));
  }
  return nn(l, Object.assign({}, ht(s, ["ref"]), l !== ae && c, l !== ae && p), u);
}
function vl(...e) {
  return { ref: e.every((t) => t == null) ? void 0 : (t) => {
    for (let r of e)
      r != null && (typeof r == "function" ? r(t) : r.current = t);
  } };
}
function Cr(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, r = {};
  for (let n of e)
    for (let l in n)
      l.startsWith("on") && typeof n[l] == "function" ? (r[l] != null || (r[l] = []), r[l].push(n[l])) : t[l] = n[l];
  if (t.disabled || t["aria-disabled"])
    return Object.assign(t, Object.fromEntries(Object.keys(r).map((n) => [n, void 0])));
  for (let n in r)
    Object.assign(t, { [n](l, ...i) {
      let a = r[n];
      for (let s of a) {
        if ((l instanceof Event || (l == null ? void 0 : l.nativeEvent) instanceof Event) && l.defaultPrevented)
          return;
        s(l, ...i);
      }
    } });
  return t;
}
function X(e) {
  var t;
  return Object.assign(br(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function Fe(e) {
  let t = Object.assign({}, e);
  for (let r in t)
    t[r] === void 0 && delete t[r];
  return t;
}
function ht(e, t = []) {
  let r = Object.assign({}, e);
  for (let n of t)
    n in r && delete r[n];
  return r;
}
function De(e) {
  let t = e.parentElement, r = null;
  for (; t && !(t instanceof HTMLFieldSetElement); )
    t instanceof HTMLLegendElement && (r = t), t = t.parentElement;
  let n = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return n && xl(r) ? !1 : n;
}
function xl(e) {
  if (!e)
    return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement)
      return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
function it(e = {}, t = null, r = []) {
  for (let [n, l] of Object.entries(e))
    Er(r, Rr(t, n), l);
  return r;
}
function Rr(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function Er(e, t, r) {
  if (Array.isArray(r))
    for (let [n, l] of r.entries())
      Er(e, Rr(t, n.toString()), l);
  else
    r instanceof Date ? e.push([t, r.toISOString()]) : typeof r == "boolean" ? e.push([t, r ? "1" : "0"]) : typeof r == "string" ? e.push([t, r]) : typeof r == "number" ? e.push([t, `${r}`]) : r == null ? e.push([t, ""]) : it(r, t, e);
}
function $r(e) {
  var t;
  let r = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (r) {
    for (let n of r.elements)
      if (n.tagName === "INPUT" && n.type === "submit" || n.tagName === "BUTTON" && n.type === "submit" || n.nodeName === "INPUT" && n.type === "image") {
        n.click();
        return;
      }
  }
}
let yl = "div";
var ze = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(ze || {});
function wl(e, t) {
  let { features: r = 1, ...n } = e, l = { ref: t, "aria-hidden": (r & 2) === 2 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(r & 4) === 4 && (r & 2) !== 2 && { display: "none" } } };
  return W({ ourProps: l, theirProps: n, slot: {}, defaultTag: yl, name: "Hidden" });
}
let st = X(wl), Gt = ue(null);
Gt.displayName = "OpenClosedContext";
var Z = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(Z || {});
function Ke() {
  return ie(Gt);
}
function ct({ value: e, children: t }) {
  return _.createElement(Gt.Provider, { value: e }, t);
}
var C = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(C || {});
function ut(e, t, r) {
  let [n, l] = H(r), i = e !== void 0, a = L(i), s = L(!1), c = L(!1);
  return i && !a.current && !s.current ? (s.current = !0, a.current = i, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !i && a.current && !c.current && (c.current = !0, a.current = i, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [i ? e : n, S((u) => (i || l(u), t == null ? void 0 : t(u)))];
}
function cr(e, t) {
  let r = L([]), n = S(e);
  U(() => {
    let l = [...r.current];
    for (let [i, a] of t.entries())
      if (r.current[i] !== a) {
        let s = n(t, l);
        return r.current = t, s;
      }
  }, [n, ...t]);
}
function ur(e) {
  return [e.screenX, e.screenY];
}
function Vt() {
  let e = L([-1, -1]);
  return { wasMoved(t) {
    let r = ur(t);
    return e.current[0] === r[0] && e.current[1] === r[1] ? !1 : (e.current = r, !0);
  }, update(t) {
    e.current = ur(t);
  } };
}
function Nl() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Sl() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Ol() {
  return Nl() || Sl();
}
var Tl = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Tl || {}), Il = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Il || {}), kl = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(kl || {}), Cl = ((e) => (e[e.OpenCombobox = 0] = "OpenCombobox", e[e.CloseCombobox = 1] = "CloseCombobox", e[e.GoToOption = 2] = "GoToOption", e[e.RegisterOption = 3] = "RegisterOption", e[e.UnregisterOption = 4] = "UnregisterOption", e[e.RegisterLabel = 5] = "RegisterLabel", e))(Cl || {});
function vt(e, t = (r) => r) {
  let r = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, n = Ue(t(e.options.slice()), (i) => i.dataRef.current.domRef.current), l = r ? n.indexOf(r) : null;
  return l === -1 && (l = null), { options: n, activeOptionIndex: l };
}
let Rl = { [1](e) {
  var t;
  return (t = e.dataRef.current) != null && t.disabled || e.comboboxState === 1 ? e : { ...e, activeOptionIndex: null, comboboxState: 1 };
}, [0](e) {
  var t;
  if ((t = e.dataRef.current) != null && t.disabled || e.comboboxState === 0)
    return e;
  let r = e.activeOptionIndex;
  if (e.dataRef.current) {
    let { isSelected: n } = e.dataRef.current, l = e.options.findIndex((i) => n(i.dataRef.current.value));
    l !== -1 && (r = l);
  }
  return { ...e, comboboxState: 0, activeOptionIndex: r };
}, [2](e, t) {
  var r, n, l, i;
  if ((r = e.dataRef.current) != null && r.disabled || (n = e.dataRef.current) != null && n.optionsRef.current && !((l = e.dataRef.current) != null && l.optionsPropsRef.current.static) && e.comboboxState === 1)
    return e;
  let a = vt(e);
  if (a.activeOptionIndex === null) {
    let c = a.options.findIndex((u) => !u.dataRef.current.disabled);
    c !== -1 && (a.activeOptionIndex = c);
  }
  let s = Ht(t, { resolveItems: () => a.options, resolveActiveIndex: () => a.activeOptionIndex, resolveId: (c) => c.id, resolveDisabled: (c) => c.dataRef.current.disabled });
  return { ...e, ...a, activeOptionIndex: s, activationTrigger: (i = t.trigger) != null ? i : 1 };
}, [3]: (e, t) => {
  var r, n;
  let l = { id: t.id, dataRef: t.dataRef }, i = vt(e, (s) => [...s, l]);
  e.activeOptionIndex === null && (r = e.dataRef.current) != null && r.isSelected(t.dataRef.current.value) && (i.activeOptionIndex = i.options.indexOf(l));
  let a = { ...e, ...i, activationTrigger: 1 };
  return (n = e.dataRef.current) != null && n.__demoMode && e.dataRef.current.value === void 0 && (a.activeOptionIndex = 0), a;
}, [4]: (e, t) => {
  let r = vt(e, (n) => {
    let l = n.findIndex((i) => i.id === t.id);
    return l !== -1 && n.splice(l, 1), n;
  });
  return { ...e, ...r, activationTrigger: 1 };
}, [5]: (e, t) => ({ ...e, labelId: t.id }) }, Ut = ue(null);
Ut.displayName = "ComboboxActionsContext";
function qe(e) {
  let t = ie(Ut);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, qe), r;
  }
  return t;
}
let zt = ue(null);
zt.displayName = "ComboboxDataContext";
function Me(e) {
  let t = ie(zt);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Me), r;
  }
  return t;
}
function El(e, t) {
  return K(t.type, Rl, e, t);
}
let $l = ae;
function Ll(e, t) {
  let { value: r, defaultValue: n, onChange: l, form: i, name: a, by: s = (O, $) => O === $, disabled: c = !1, __demoMode: u = !1, nullable: p = !1, multiple: d = !1, ...m } = e, [f = d ? [] : void 0, b] = ut(r, l, n), [g, y] = Je(El, { dataRef: Ye(), comboboxState: u ? 0 : 1, options: [], activeOptionIndex: null, activationTrigger: 1, labelId: null }), w = L(!1), v = L({ static: !1, hold: !1 }), M = L(null), R = L(null), E = L(null), I = L(null), N = S(typeof s == "string" ? (O, $) => {
    let B = s;
    return (O == null ? void 0 : O[B]) === ($ == null ? void 0 : $[B]);
  } : s), D = Re((O) => K(k.mode, { [1]: () => f.some(($) => N($, O)), [0]: () => N(f, O) }), [f]), k = j(() => ({ ...g, optionsPropsRef: v, labelRef: M, inputRef: R, buttonRef: E, optionsRef: I, value: f, defaultValue: n, disabled: c, mode: d ? 1 : 0, get activeOptionIndex() {
    if (w.current && g.activeOptionIndex === null && g.options.length > 0) {
      let O = g.options.findIndex(($) => !$.dataRef.current.disabled);
      if (O !== -1)
        return O;
    }
    return g.activeOptionIndex;
  }, compare: N, isSelected: D, nullable: p, __demoMode: u }), [f, n, c, d, p, u, g]), G = L(k.activeOptionIndex !== null ? k.options[k.activeOptionIndex] : null);
  U(() => {
    let O = k.activeOptionIndex !== null ? k.options[k.activeOptionIndex] : null;
    G.current !== O && (G.current = O);
  }), z(() => {
    g.dataRef.current = k;
  }, [k]), jt([k.buttonRef, k.inputRef, k.optionsRef], () => J.closeCombobox(), k.comboboxState === 0);
  let P = j(() => ({ open: k.comboboxState === 0, disabled: c, activeIndex: k.activeOptionIndex, activeOption: k.activeOptionIndex === null ? null : k.options[k.activeOptionIndex].dataRef.current.value, value: f }), [k, c, f]), Q = S((O) => {
    let $ = k.options.find((B) => B.id === O);
    $ && F($.dataRef.current.value);
  }), Y = S(() => {
    if (k.activeOptionIndex !== null) {
      let { dataRef: O, id: $ } = k.options[k.activeOptionIndex];
      F(O.current.value), J.goToOption(A.Specific, $);
    }
  }), fe = S(() => {
    y({ type: 0 }), w.current = !0;
  }), se = S(() => {
    y({ type: 1 }), w.current = !1;
  }), he = S((O, $, B) => (w.current = !1, O === A.Specific ? y({ type: 2, focus: A.Specific, id: $, trigger: B }) : y({ type: 2, focus: O, trigger: B }))), ne = S((O, $) => (y({ type: 3, id: O, dataRef: $ }), () => {
    var B;
    ((B = G.current) == null ? void 0 : B.id) === O && (w.current = !0), y({ type: 4, id: O });
  })), ve = S((O) => (y({ type: 5, id: O }), () => y({ type: 5, id: null }))), F = S((O) => K(k.mode, { [0]() {
    return b == null ? void 0 : b(O);
  }, [1]() {
    let $ = k.value.slice(), B = $.findIndex((xe) => N(xe, O));
    return B === -1 ? $.push(O) : $.splice(B, 1), b == null ? void 0 : b($);
  } })), J = j(() => ({ onChange: F, registerOption: ne, registerLabel: ve, goToOption: he, closeCombobox: se, openCombobox: fe, selectActiveOption: Y, selectOption: Q }), []), V = t === null ? {} : { ref: t }, le = L(null), re = de();
  return U(() => {
    le.current && n !== void 0 && re.addEventListener(le.current, "reset", () => {
      F(n);
    });
  }, [le, F]), _.createElement(Ut.Provider, { value: J }, _.createElement(zt.Provider, { value: k }, _.createElement(ct, { value: K(k.comboboxState, { [0]: Z.Open, [1]: Z.Closed }) }, a != null && f != null && it({ [a]: f }).map(([O, $], B) => _.createElement(st, { features: ze.Hidden, ref: B === 0 ? (xe) => {
    var Be;
    le.current = (Be = xe == null ? void 0 : xe.closest("form")) != null ? Be : null;
  } : void 0, ...Fe({ key: O, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: i, name: O, value: $ }) })), W({ ourProps: V, theirProps: m, slot: P, defaultTag: $l, name: "Combobox" }))));
}
let Pl = "input";
function Fl(e, t) {
  var r, n, l, i;
  let a = oe(), { id: s = `headlessui-combobox-input-${a}`, onChange: c, displayValue: u, type: p = "text", ...d } = e, m = Me("Combobox.Input"), f = qe("Combobox.Input"), b = ee(m.inputRef, t), g = L(!1), y = de(), w = function() {
    var P;
    return typeof u == "function" && m.value !== void 0 ? (P = u(m.value)) != null ? P : "" : typeof m.value == "string" ? m.value : "";
  }();
  cr(([P, Q], [Y, fe]) => {
    g.current || m.inputRef.current && (fe === 0 && Q === 1 || P !== Y) && (m.inputRef.current.value = P);
  }, [w, m.comboboxState]), cr(([P], [Q]) => {
    if (P === 0 && Q === 1) {
      let Y = m.inputRef.current;
      if (!Y)
        return;
      let fe = Y.value, { selectionStart: se, selectionEnd: he, selectionDirection: ne } = Y;
      Y.value = "", Y.value = fe, ne !== null ? Y.setSelectionRange(se, he, ne) : Y.setSelectionRange(se, he);
    }
  }, [m.comboboxState]);
  let v = L(!1), M = S(() => {
    v.current = !0;
  }), R = S(() => {
    setTimeout(() => {
      v.current = !1;
    });
  }), E = S((P) => {
    switch (g.current = !0, P.key) {
      case C.Backspace:
      case C.Delete:
        if (m.mode !== 0 || !m.nullable)
          return;
        let Q = P.currentTarget;
        y.requestAnimationFrame(() => {
          Q.value === "" && (f.onChange(null), m.optionsRef.current && (m.optionsRef.current.scrollTop = 0), f.goToOption(A.Nothing));
        });
        break;
      case C.Enter:
        if (g.current = !1, m.comboboxState !== 0 || v.current)
          return;
        if (P.preventDefault(), P.stopPropagation(), m.activeOptionIndex === null) {
          f.closeCombobox();
          return;
        }
        f.selectActiveOption(), m.mode === 0 && f.closeCombobox();
        break;
      case C.ArrowDown:
        return g.current = !1, P.preventDefault(), P.stopPropagation(), K(m.comboboxState, { [0]: () => {
          f.goToOption(A.Next);
        }, [1]: () => {
          f.openCombobox();
        } });
      case C.ArrowUp:
        return g.current = !1, P.preventDefault(), P.stopPropagation(), K(m.comboboxState, { [0]: () => {
          f.goToOption(A.Previous);
        }, [1]: () => {
          f.openCombobox(), y.nextFrame(() => {
            m.value || f.goToOption(A.Last);
          });
        } });
      case C.Home:
        if (P.shiftKey)
          break;
        return g.current = !1, P.preventDefault(), P.stopPropagation(), f.goToOption(A.First);
      case C.PageUp:
        return g.current = !1, P.preventDefault(), P.stopPropagation(), f.goToOption(A.First);
      case C.End:
        if (P.shiftKey)
          break;
        return g.current = !1, P.preventDefault(), P.stopPropagation(), f.goToOption(A.Last);
      case C.PageDown:
        return g.current = !1, P.preventDefault(), P.stopPropagation(), f.goToOption(A.Last);
      case C.Escape:
        return g.current = !1, m.comboboxState !== 0 ? void 0 : (P.preventDefault(), m.optionsRef.current && !m.optionsPropsRef.current.static && P.stopPropagation(), f.closeCombobox());
      case C.Tab:
        if (g.current = !1, m.comboboxState !== 0)
          return;
        m.mode === 0 && f.selectActiveOption(), f.closeCombobox();
        break;
    }
  }), I = S((P) => {
    f.openCombobox(), c == null || c(P);
  }), N = S(() => {
    g.current = !1;
  }), D = Ve(() => {
    if (m.labelId)
      return [m.labelId].join(" ");
  }, [m.labelId]), k = j(() => ({ open: m.comboboxState === 0, disabled: m.disabled }), [m]), G = { ref: b, id: s, role: "combobox", type: p, "aria-controls": (r = m.optionsRef.current) == null ? void 0 : r.id, "aria-expanded": m.disabled ? void 0 : m.comboboxState === 0, "aria-activedescendant": m.activeOptionIndex === null || (n = m.options[m.activeOptionIndex]) == null ? void 0 : n.id, "aria-labelledby": D, "aria-autocomplete": "list", defaultValue: (i = (l = e.defaultValue) != null ? l : m.defaultValue !== void 0 ? u == null ? void 0 : u(m.defaultValue) : null) != null ? i : m.defaultValue, disabled: m.disabled, onCompositionStart: M, onCompositionEnd: R, onKeyDown: E, onChange: I, onBlur: N };
  return W({ ourProps: G, theirProps: d, slot: k, defaultTag: Pl, name: "Combobox.Input" });
}
let Dl = "button";
function Al(e, t) {
  var r;
  let n = Me("Combobox.Button"), l = qe("Combobox.Button"), i = ee(n.buttonRef, t), a = oe(), { id: s = `headlessui-combobox-button-${a}`, ...c } = e, u = de(), p = S((g) => {
    switch (g.key) {
      case C.ArrowDown:
        return g.preventDefault(), g.stopPropagation(), n.comboboxState === 1 && l.openCombobox(), u.nextFrame(() => {
          var y;
          return (y = n.inputRef.current) == null ? void 0 : y.focus({ preventScroll: !0 });
        });
      case C.ArrowUp:
        return g.preventDefault(), g.stopPropagation(), n.comboboxState === 1 && (l.openCombobox(), u.nextFrame(() => {
          n.value || l.goToOption(A.Last);
        })), u.nextFrame(() => {
          var y;
          return (y = n.inputRef.current) == null ? void 0 : y.focus({ preventScroll: !0 });
        });
      case C.Escape:
        return n.comboboxState !== 0 ? void 0 : (g.preventDefault(), n.optionsRef.current && !n.optionsPropsRef.current.static && g.stopPropagation(), l.closeCombobox(), u.nextFrame(() => {
          var y;
          return (y = n.inputRef.current) == null ? void 0 : y.focus({ preventScroll: !0 });
        }));
      default:
        return;
    }
  }), d = S((g) => {
    if (De(g.currentTarget))
      return g.preventDefault();
    n.comboboxState === 0 ? l.closeCombobox() : (g.preventDefault(), l.openCombobox()), u.nextFrame(() => {
      var y;
      return (y = n.inputRef.current) == null ? void 0 : y.focus({ preventScroll: !0 });
    });
  }), m = Ve(() => {
    if (n.labelId)
      return [n.labelId, s].join(" ");
  }, [n.labelId, s]), f = j(() => ({ open: n.comboboxState === 0, disabled: n.disabled, value: n.value }), [n]), b = { ref: i, id: s, type: at(e, n.buttonRef), tabIndex: -1, "aria-haspopup": "listbox", "aria-controls": (r = n.optionsRef.current) == null ? void 0 : r.id, "aria-expanded": n.disabled ? void 0 : n.comboboxState === 0, "aria-labelledby": m, disabled: n.disabled, onClick: d, onKeyDown: p };
  return W({ ourProps: b, theirProps: c, slot: f, defaultTag: Dl, name: "Combobox.Button" });
}
let Ml = "label";
function _l(e, t) {
  let r = oe(), { id: n = `headlessui-combobox-label-${r}`, ...l } = e, i = Me("Combobox.Label"), a = qe("Combobox.Label"), s = ee(i.labelRef, t);
  z(() => a.registerLabel(n), [n]);
  let c = S(() => {
    var p;
    return (p = i.inputRef.current) == null ? void 0 : p.focus({ preventScroll: !0 });
  }), u = j(() => ({ open: i.comboboxState === 0, disabled: i.disabled }), [i]);
  return W({ ourProps: { ref: s, id: n, onClick: c }, theirProps: l, slot: u, defaultTag: Ml, name: "Combobox.Label" });
}
let jl = "ul", Bl = Te.RenderStrategy | Te.Static;
function Hl(e, t) {
  let r = oe(), { id: n = `headlessui-combobox-options-${r}`, hold: l = !1, ...i } = e, a = Me("Combobox.Options"), s = ee(a.optionsRef, t), c = Ke(), u = (() => c !== null ? (c & Z.Open) === Z.Open : a.comboboxState === 0)();
  z(() => {
    var f;
    a.optionsPropsRef.current.static = (f = e.static) != null ? f : !1;
  }, [a.optionsPropsRef, e.static]), z(() => {
    a.optionsPropsRef.current.hold = l;
  }, [a.optionsPropsRef, l]), Bt({ container: a.optionsRef.current, enabled: a.comboboxState === 0, accept(f) {
    return f.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : f.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(f) {
    f.setAttribute("role", "none");
  } });
  let p = Ve(() => {
    var f, b;
    return (b = a.labelId) != null ? b : (f = a.buttonRef.current) == null ? void 0 : f.id;
  }, [a.labelId, a.buttonRef.current]), d = j(() => ({ open: a.comboboxState === 0 }), [a]), m = { "aria-labelledby": p, role: "listbox", "aria-multiselectable": a.mode === 1 ? !0 : void 0, id: n, ref: s };
  return W({ ourProps: m, theirProps: i, slot: d, defaultTag: jl, features: Bl, visible: u, name: "Combobox.Options" });
}
let Gl = "li";
function Vl(e, t) {
  var r, n;
  let l = oe(), { id: i = `headlessui-combobox-option-${l}`, disabled: a = !1, value: s, ...c } = e, u = Me("Combobox.Option"), p = qe("Combobox.Option"), d = u.activeOptionIndex !== null ? u.options[u.activeOptionIndex].id === i : !1, m = u.isSelected(s), f = L(null), b = be({ disabled: a, value: s, domRef: f, textValue: (n = (r = f.current) == null ? void 0 : r.textContent) == null ? void 0 : n.toLowerCase() }), g = ee(t, f), y = S(() => p.selectOption(i));
  z(() => p.registerOption(i, b), [b, i]);
  let w = L(!u.__demoMode);
  z(() => {
    if (!u.__demoMode)
      return;
    let k = ce();
    return k.requestAnimationFrame(() => {
      w.current = !0;
    }), k.dispose;
  }, []), z(() => {
    if (u.comboboxState !== 0 || !d || !w.current || u.activationTrigger === 0)
      return;
    let k = ce();
    return k.requestAnimationFrame(() => {
      var G, P;
      (P = (G = f.current) == null ? void 0 : G.scrollIntoView) == null || P.call(G, { block: "nearest" });
    }), k.dispose;
  }, [f, d, u.comboboxState, u.activationTrigger, u.activeOptionIndex]);
  let v = S((k) => {
    if (a)
      return k.preventDefault();
    y(), u.mode === 0 && p.closeCombobox(), Ol() || requestAnimationFrame(() => {
      var G;
      return (G = u.inputRef.current) == null ? void 0 : G.focus();
    });
  }), M = S(() => {
    if (a)
      return p.goToOption(A.Nothing);
    p.goToOption(A.Specific, i);
  }), R = Vt(), E = S((k) => R.update(k)), I = S((k) => {
    R.wasMoved(k) && (a || d || p.goToOption(A.Specific, i, 0));
  }), N = S((k) => {
    R.wasMoved(k) && (a || d && (u.optionsPropsRef.current.hold || p.goToOption(A.Nothing)));
  }), D = j(() => ({ active: d, selected: m, disabled: a }), [d, m, a]);
  return W({ ourProps: { id: i, ref: g, role: "option", tabIndex: a === !0 ? void 0 : -1, "aria-disabled": a === !0 ? !0 : void 0, "aria-selected": m, disabled: void 0, onClick: v, onFocus: M, onPointerEnter: E, onMouseEnter: E, onPointerMove: I, onMouseMove: I, onPointerLeave: N, onMouseLeave: N }, theirProps: c, slot: D, defaultTag: Gl, name: "Combobox.Option" });
}
let Ul = X(Ll), zl = X(Al), Kl = X(Fl), ql = X(_l), Wl = X(Hl), Xl = X(Vl), q = Object.assign(Ul, { Input: Kl, Button: zl, Label: ql, Options: Wl, Option: Xl });
function Kt() {
  let e = L(!1);
  return z(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function Ql(...e) {
  return j(() => Ae(...e), [...e]);
}
let Lr = ue(null);
function Pr() {
  let e = ie(Lr);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, Pr), t;
  }
  return e;
}
function qt() {
  let [e, t] = H([]);
  return [e.length > 0 ? e.join(" ") : void 0, j(() => function(r) {
    let n = S((i) => (t((a) => [...a, i]), () => t((a) => {
      let s = a.slice(), c = s.indexOf(i);
      return c !== -1 && s.splice(c, 1), s;
    }))), l = j(() => ({ register: n, slot: r.slot, name: r.name, props: r.props }), [n, r.slot, r.name, r.props]);
    return _.createElement(Lr.Provider, { value: l }, r.children);
  }, [t])];
}
let Yl = "p";
function Jl(e, t) {
  let r = oe(), { id: n = `headlessui-description-${r}`, ...l } = e, i = Pr(), a = ee(t);
  z(() => i.register(n), [n, i.register]);
  let s = { ref: a, ...i.props, id: n };
  return W({ ourProps: s, theirProps: l, slot: i.slot || {}, defaultTag: Yl, name: i.name || "Description" });
}
let Zl = X(Jl), Fr = Object.assign(Zl, {});
var eo = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(eo || {}), to = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(to || {}), ro = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(ro || {}), no = ((e) => (e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.GoToOption = 2] = "GoToOption", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterOption = 5] = "RegisterOption", e[e.UnregisterOption = 6] = "UnregisterOption", e[e.RegisterLabel = 7] = "RegisterLabel", e))(no || {});
function xt(e, t = (r) => r) {
  let r = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, n = Ue(t(e.options.slice()), (i) => i.dataRef.current.domRef.current), l = r ? n.indexOf(r) : null;
  return l === -1 && (l = null), { options: n, activeOptionIndex: l };
}
let lo = { [1](e) {
  return e.dataRef.current.disabled || e.listboxState === 1 ? e : { ...e, activeOptionIndex: null, listboxState: 1 };
}, [0](e) {
  if (e.dataRef.current.disabled || e.listboxState === 0)
    return e;
  let t = e.activeOptionIndex, { isSelected: r } = e.dataRef.current, n = e.options.findIndex((l) => r(l.dataRef.current.value));
  return n !== -1 && (t = n), { ...e, listboxState: 0, activeOptionIndex: t };
}, [2](e, t) {
  var r;
  if (e.dataRef.current.disabled || e.listboxState === 1)
    return e;
  let n = xt(e), l = Ht(t, { resolveItems: () => n.options, resolveActiveIndex: () => n.activeOptionIndex, resolveId: (i) => i.id, resolveDisabled: (i) => i.dataRef.current.disabled });
  return { ...e, ...n, searchQuery: "", activeOptionIndex: l, activationTrigger: (r = t.trigger) != null ? r : 1 };
}, [3]: (e, t) => {
  if (e.dataRef.current.disabled || e.listboxState === 1)
    return e;
  let r = e.searchQuery !== "" ? 0 : 1, n = e.searchQuery + t.value.toLowerCase(), l = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + r).concat(e.options.slice(0, e.activeOptionIndex + r)) : e.options).find((a) => {
    var s;
    return !a.dataRef.current.disabled && ((s = a.dataRef.current.textValue) == null ? void 0 : s.startsWith(n));
  }), i = l ? e.options.indexOf(l) : -1;
  return i === -1 || i === e.activeOptionIndex ? { ...e, searchQuery: n } : { ...e, searchQuery: n, activeOptionIndex: i, activationTrigger: 1 };
}, [4](e) {
  return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : { ...e, searchQuery: "" };
}, [5]: (e, t) => {
  let r = { id: t.id, dataRef: t.dataRef }, n = xt(e, (l) => [...l, r]);
  return e.activeOptionIndex === null && e.dataRef.current.isSelected(t.dataRef.current.value) && (n.activeOptionIndex = n.options.indexOf(r)), { ...e, ...n };
}, [6]: (e, t) => {
  let r = xt(e, (n) => {
    let l = n.findIndex((i) => i.id === t.id);
    return l !== -1 && n.splice(l, 1), n;
  });
  return { ...e, ...r, activationTrigger: 1 };
}, [7]: (e, t) => ({ ...e, labelId: t.id }) }, Wt = ue(null);
Wt.displayName = "ListboxActionsContext";
function We(e) {
  let t = ie(Wt);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, We), r;
  }
  return t;
}
let Xt = ue(null);
Xt.displayName = "ListboxDataContext";
function Xe(e) {
  let t = ie(Xt);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Xe), r;
  }
  return t;
}
function oo(e, t) {
  return K(t.type, lo, e, t);
}
let ao = ae;
function io(e, t) {
  let { value: r, defaultValue: n, form: l, name: i, onChange: a, by: s = (O, $) => O === $, disabled: c = !1, horizontal: u = !1, multiple: p = !1, ...d } = e;
  const m = u ? "horizontal" : "vertical";
  let f = ee(t), [b = p ? [] : void 0, g] = ut(r, a, n), [y, w] = Je(oo, { dataRef: Ye(), listboxState: 1, options: [], searchQuery: "", labelId: null, activeOptionIndex: null, activationTrigger: 1 }), v = L({ static: !1, hold: !1 }), M = L(null), R = L(null), E = L(null), I = S(typeof s == "string" ? (O, $) => {
    let B = s;
    return (O == null ? void 0 : O[B]) === ($ == null ? void 0 : $[B]);
  } : s), N = Re((O) => K(D.mode, { [1]: () => b.some(($) => I($, O)), [0]: () => I(b, O) }), [b]), D = j(() => ({ ...y, value: b, disabled: c, mode: p ? 1 : 0, orientation: m, compare: I, isSelected: N, optionsPropsRef: v, labelRef: M, buttonRef: R, optionsRef: E }), [b, c, p, y]);
  z(() => {
    y.dataRef.current = D;
  }, [D]), jt([D.buttonRef, D.optionsRef], (O, $) => {
    var B;
    w({ type: 1 }), ot($, lt.Loose) || (O.preventDefault(), (B = D.buttonRef.current) == null || B.focus());
  }, D.listboxState === 0);
  let k = j(() => ({ open: D.listboxState === 0, disabled: c, value: b }), [D, c, b]), G = S((O) => {
    let $ = D.options.find((B) => B.id === O);
    $ && ne($.dataRef.current.value);
  }), P = S(() => {
    if (D.activeOptionIndex !== null) {
      let { dataRef: O, id: $ } = D.options[D.activeOptionIndex];
      ne(O.current.value), w({ type: 2, focus: A.Specific, id: $ });
    }
  }), Q = S(() => w({ type: 0 })), Y = S(() => w({ type: 1 })), fe = S((O, $, B) => O === A.Specific ? w({ type: 2, focus: A.Specific, id: $, trigger: B }) : w({ type: 2, focus: O, trigger: B })), se = S((O, $) => (w({ type: 5, id: O, dataRef: $ }), () => w({ type: 6, id: O }))), he = S((O) => (w({ type: 7, id: O }), () => w({ type: 7, id: null }))), ne = S((O) => K(D.mode, { [0]() {
    return g == null ? void 0 : g(O);
  }, [1]() {
    let $ = D.value.slice(), B = $.findIndex((xe) => I(xe, O));
    return B === -1 ? $.push(O) : $.splice(B, 1), g == null ? void 0 : g($);
  } })), ve = S((O) => w({ type: 3, value: O })), F = S(() => w({ type: 4 })), J = j(() => ({ onChange: ne, registerOption: se, registerLabel: he, goToOption: fe, closeListbox: Y, openListbox: Q, selectActiveOption: P, selectOption: G, search: ve, clearSearch: F }), []), V = { ref: f }, le = L(null), re = de();
  return U(() => {
    le.current && n !== void 0 && re.addEventListener(le.current, "reset", () => {
      ne(n);
    });
  }, [le, ne]), _.createElement(Wt.Provider, { value: J }, _.createElement(Xt.Provider, { value: D }, _.createElement(ct, { value: K(D.listboxState, { [0]: Z.Open, [1]: Z.Closed }) }, i != null && b != null && it({ [i]: b }).map(([O, $], B) => _.createElement(st, { features: ze.Hidden, ref: B === 0 ? (xe) => {
    var Be;
    le.current = (Be = xe == null ? void 0 : xe.closest("form")) != null ? Be : null;
  } : void 0, ...Fe({ key: O, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: l, name: O, value: $ }) })), W({ ourProps: V, theirProps: d, slot: k, defaultTag: ao, name: "Listbox" }))));
}
let so = "button";
function co(e, t) {
  var r;
  let n = oe(), { id: l = `headlessui-listbox-button-${n}`, ...i } = e, a = Xe("Listbox.Button"), s = We("Listbox.Button"), c = ee(a.buttonRef, t), u = de(), p = S((y) => {
    switch (y.key) {
      case C.Space:
      case C.Enter:
      case C.ArrowDown:
        y.preventDefault(), s.openListbox(), u.nextFrame(() => {
          a.value || s.goToOption(A.First);
        });
        break;
      case C.ArrowUp:
        y.preventDefault(), s.openListbox(), u.nextFrame(() => {
          a.value || s.goToOption(A.Last);
        });
        break;
    }
  }), d = S((y) => {
    switch (y.key) {
      case C.Space:
        y.preventDefault();
        break;
    }
  }), m = S((y) => {
    if (De(y.currentTarget))
      return y.preventDefault();
    a.listboxState === 0 ? (s.closeListbox(), u.nextFrame(() => {
      var w;
      return (w = a.buttonRef.current) == null ? void 0 : w.focus({ preventScroll: !0 });
    })) : (y.preventDefault(), s.openListbox());
  }), f = Ve(() => {
    if (a.labelId)
      return [a.labelId, l].join(" ");
  }, [a.labelId, l]), b = j(() => ({ open: a.listboxState === 0, disabled: a.disabled, value: a.value }), [a]), g = { ref: c, id: l, type: at(e, a.buttonRef), "aria-haspopup": "listbox", "aria-controls": (r = a.optionsRef.current) == null ? void 0 : r.id, "aria-expanded": a.disabled ? void 0 : a.listboxState === 0, "aria-labelledby": f, disabled: a.disabled, onKeyDown: p, onKeyUp: d, onClick: m };
  return W({ ourProps: g, theirProps: i, slot: b, defaultTag: so, name: "Listbox.Button" });
}
let uo = "label";
function po(e, t) {
  let r = oe(), { id: n = `headlessui-listbox-label-${r}`, ...l } = e, i = Xe("Listbox.Label"), a = We("Listbox.Label"), s = ee(i.labelRef, t);
  z(() => a.registerLabel(n), [n]);
  let c = S(() => {
    var p;
    return (p = i.buttonRef.current) == null ? void 0 : p.focus({ preventScroll: !0 });
  }), u = j(() => ({ open: i.listboxState === 0, disabled: i.disabled }), [i]);
  return W({ ourProps: { ref: s, id: n, onClick: c }, theirProps: l, slot: u, defaultTag: uo, name: "Listbox.Label" });
}
let mo = "ul", fo = Te.RenderStrategy | Te.Static;
function bo(e, t) {
  var r;
  let n = oe(), { id: l = `headlessui-listbox-options-${n}`, ...i } = e, a = Xe("Listbox.Options"), s = We("Listbox.Options"), c = ee(a.optionsRef, t), u = de(), p = de(), d = Ke(), m = (() => d !== null ? (d & Z.Open) === Z.Open : a.listboxState === 0)();
  U(() => {
    var w;
    let v = a.optionsRef.current;
    v && a.listboxState === 0 && v !== ((w = Ae(v)) == null ? void 0 : w.activeElement) && v.focus({ preventScroll: !0 });
  }, [a.listboxState, a.optionsRef]);
  let f = S((w) => {
    switch (p.dispose(), w.key) {
      case C.Space:
        if (a.searchQuery !== "")
          return w.preventDefault(), w.stopPropagation(), s.search(w.key);
      case C.Enter:
        if (w.preventDefault(), w.stopPropagation(), a.activeOptionIndex !== null) {
          let { dataRef: v } = a.options[a.activeOptionIndex];
          s.onChange(v.current.value);
        }
        a.mode === 0 && (s.closeListbox(), ce().nextFrame(() => {
          var v;
          return (v = a.buttonRef.current) == null ? void 0 : v.focus({ preventScroll: !0 });
        }));
        break;
      case K(a.orientation, { vertical: C.ArrowDown, horizontal: C.ArrowRight }):
        return w.preventDefault(), w.stopPropagation(), s.goToOption(A.Next);
      case K(a.orientation, { vertical: C.ArrowUp, horizontal: C.ArrowLeft }):
        return w.preventDefault(), w.stopPropagation(), s.goToOption(A.Previous);
      case C.Home:
      case C.PageUp:
        return w.preventDefault(), w.stopPropagation(), s.goToOption(A.First);
      case C.End:
      case C.PageDown:
        return w.preventDefault(), w.stopPropagation(), s.goToOption(A.Last);
      case C.Escape:
        return w.preventDefault(), w.stopPropagation(), s.closeListbox(), u.nextFrame(() => {
          var v;
          return (v = a.buttonRef.current) == null ? void 0 : v.focus({ preventScroll: !0 });
        });
      case C.Tab:
        w.preventDefault(), w.stopPropagation();
        break;
      default:
        w.key.length === 1 && (s.search(w.key), p.setTimeout(() => s.clearSearch(), 350));
        break;
    }
  }), b = Ve(() => {
    var w, v, M;
    return (M = (w = a.labelRef.current) == null ? void 0 : w.id) != null ? M : (v = a.buttonRef.current) == null ? void 0 : v.id;
  }, [a.labelRef.current, a.buttonRef.current]), g = j(() => ({ open: a.listboxState === 0 }), [a]), y = { "aria-activedescendant": a.activeOptionIndex === null || (r = a.options[a.activeOptionIndex]) == null ? void 0 : r.id, "aria-multiselectable": a.mode === 1 ? !0 : void 0, "aria-labelledby": b, "aria-orientation": a.orientation, id: l, onKeyDown: f, role: "listbox", tabIndex: 0, ref: c };
  return W({ ourProps: y, theirProps: i, slot: g, defaultTag: mo, features: fo, visible: m, name: "Listbox.Options" });
}
let go = "li";
function ho(e, t) {
  let r = oe(), { id: n = `headlessui-listbox-option-${r}`, disabled: l = !1, value: i, ...a } = e, s = Xe("Listbox.Option"), c = We("Listbox.Option"), u = s.activeOptionIndex !== null ? s.options[s.activeOptionIndex].id === n : !1, p = s.isSelected(i), d = L(null), m = be({ disabled: l, value: i, domRef: d, get textValue() {
    var E, I;
    return (I = (E = d.current) == null ? void 0 : E.textContent) == null ? void 0 : I.toLowerCase();
  } }), f = ee(t, d);
  z(() => {
    if (s.listboxState !== 0 || !u || s.activationTrigger === 0)
      return;
    let E = ce();
    return E.requestAnimationFrame(() => {
      var I, N;
      (N = (I = d.current) == null ? void 0 : I.scrollIntoView) == null || N.call(I, { block: "nearest" });
    }), E.dispose;
  }, [d, u, s.listboxState, s.activationTrigger, s.activeOptionIndex]), z(() => c.registerOption(n, m), [m, n]);
  let b = S((E) => {
    if (l)
      return E.preventDefault();
    c.onChange(i), s.mode === 0 && (c.closeListbox(), ce().nextFrame(() => {
      var I;
      return (I = s.buttonRef.current) == null ? void 0 : I.focus({ preventScroll: !0 });
    }));
  }), g = S(() => {
    if (l)
      return c.goToOption(A.Nothing);
    c.goToOption(A.Specific, n);
  }), y = Vt(), w = S((E) => y.update(E)), v = S((E) => {
    y.wasMoved(E) && (l || u || c.goToOption(A.Specific, n, 0));
  }), M = S((E) => {
    y.wasMoved(E) && (l || u && c.goToOption(A.Nothing));
  }), R = j(() => ({ active: u, selected: p, disabled: l }), [u, p, l]);
  return W({ ourProps: { id: n, ref: f, role: "option", tabIndex: l === !0 ? void 0 : -1, "aria-disabled": l === !0 ? !0 : void 0, "aria-selected": p, disabled: void 0, onClick: b, onFocus: g, onPointerEnter: w, onMouseEnter: w, onPointerMove: v, onMouseMove: v, onPointerLeave: M, onMouseLeave: M }, theirProps: a, slot: R, defaultTag: go, name: "Listbox.Option" });
}
let vo = X(io), xo = X(co), yo = X(po), wo = X(bo), No = X(ho), ye = Object.assign(vo, { Button: xo, Label: yo, Options: wo, Option: No });
var So = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(So || {}), Oo = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(Oo || {}), To = ((e) => (e[e.OpenMenu = 0] = "OpenMenu", e[e.CloseMenu = 1] = "CloseMenu", e[e.GoToItem = 2] = "GoToItem", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterItem = 5] = "RegisterItem", e[e.UnregisterItem = 6] = "UnregisterItem", e))(To || {});
function yt(e, t = (r) => r) {
  let r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, n = Ue(t(e.items.slice()), (i) => i.dataRef.current.domRef.current), l = r ? n.indexOf(r) : null;
  return l === -1 && (l = null), { items: n, activeItemIndex: l };
}
let Io = { [1](e) {
  return e.menuState === 1 ? e : { ...e, activeItemIndex: null, menuState: 1 };
}, [0](e) {
  return e.menuState === 0 ? e : { ...e, menuState: 0 };
}, [2]: (e, t) => {
  var r;
  let n = yt(e), l = Ht(t, { resolveItems: () => n.items, resolveActiveIndex: () => n.activeItemIndex, resolveId: (i) => i.id, resolveDisabled: (i) => i.dataRef.current.disabled });
  return { ...e, ...n, searchQuery: "", activeItemIndex: l, activationTrigger: (r = t.trigger) != null ? r : 1 };
}, [3]: (e, t) => {
  let r = e.searchQuery !== "" ? 0 : 1, n = e.searchQuery + t.value.toLowerCase(), l = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + r).concat(e.items.slice(0, e.activeItemIndex + r)) : e.items).find((a) => {
    var s;
    return ((s = a.dataRef.current.textValue) == null ? void 0 : s.startsWith(n)) && !a.dataRef.current.disabled;
  }), i = l ? e.items.indexOf(l) : -1;
  return i === -1 || i === e.activeItemIndex ? { ...e, searchQuery: n } : { ...e, searchQuery: n, activeItemIndex: i, activationTrigger: 1 };
}, [4](e) {
  return e.searchQuery === "" ? e : { ...e, searchQuery: "", searchActiveItemIndex: null };
}, [5]: (e, t) => {
  let r = yt(e, (n) => [...n, { id: t.id, dataRef: t.dataRef }]);
  return { ...e, ...r };
}, [6]: (e, t) => {
  let r = yt(e, (n) => {
    let l = n.findIndex((i) => i.id === t.id);
    return l !== -1 && n.splice(l, 1), n;
  });
  return { ...e, ...r, activationTrigger: 1 };
} }, Qt = ue(null);
Qt.displayName = "MenuContext";
function dt(e) {
  let t = ie(Qt);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, dt), r;
  }
  return t;
}
function ko(e, t) {
  return K(t.type, Io, e, t);
}
let Co = ae;
function Ro(e, t) {
  let r = Je(ko, { menuState: 1, buttonRef: Ye(), itemsRef: Ye(), items: [], searchQuery: "", activeItemIndex: null, activationTrigger: 1 }), [{ menuState: n, itemsRef: l, buttonRef: i }, a] = r, s = ee(t);
  jt([i, l], (m, f) => {
    var b;
    a({ type: 1 }), ot(f, lt.Loose) || (m.preventDefault(), (b = i.current) == null || b.focus());
  }, n === 0);
  let c = S(() => {
    a({ type: 1 });
  }), u = j(() => ({ open: n === 0, close: c }), [n, c]), p = e, d = { ref: s };
  return _.createElement(Qt.Provider, { value: r }, _.createElement(ct, { value: K(n, { [0]: Z.Open, [1]: Z.Closed }) }, W({ ourProps: d, theirProps: p, slot: u, defaultTag: Co, name: "Menu" })));
}
let Eo = "button";
function $o(e, t) {
  var r;
  let n = oe(), { id: l = `headlessui-menu-button-${n}`, ...i } = e, [a, s] = dt("Menu.Button"), c = ee(a.buttonRef, t), u = de(), p = S((g) => {
    switch (g.key) {
      case C.Space:
      case C.Enter:
      case C.ArrowDown:
        g.preventDefault(), g.stopPropagation(), s({ type: 0 }), u.nextFrame(() => s({ type: 2, focus: A.First }));
        break;
      case C.ArrowUp:
        g.preventDefault(), g.stopPropagation(), s({ type: 0 }), u.nextFrame(() => s({ type: 2, focus: A.Last }));
        break;
    }
  }), d = S((g) => {
    switch (g.key) {
      case C.Space:
        g.preventDefault();
        break;
    }
  }), m = S((g) => {
    if (De(g.currentTarget))
      return g.preventDefault();
    e.disabled || (a.menuState === 0 ? (s({ type: 1 }), u.nextFrame(() => {
      var y;
      return (y = a.buttonRef.current) == null ? void 0 : y.focus({ preventScroll: !0 });
    })) : (g.preventDefault(), s({ type: 0 })));
  }), f = j(() => ({ open: a.menuState === 0 }), [a]), b = { ref: c, id: l, type: at(e, a.buttonRef), "aria-haspopup": "menu", "aria-controls": (r = a.itemsRef.current) == null ? void 0 : r.id, "aria-expanded": e.disabled ? void 0 : a.menuState === 0, onKeyDown: p, onKeyUp: d, onClick: m };
  return W({ ourProps: b, theirProps: i, slot: f, defaultTag: Eo, name: "Menu.Button" });
}
let Lo = "div", Po = Te.RenderStrategy | Te.Static;
function Fo(e, t) {
  var r, n;
  let l = oe(), { id: i = `headlessui-menu-items-${l}`, ...a } = e, [s, c] = dt("Menu.Items"), u = ee(s.itemsRef, t), p = Ql(s.itemsRef), d = de(), m = Ke(), f = (() => m !== null ? (m & Z.Open) === Z.Open : s.menuState === 0)();
  U(() => {
    let v = s.itemsRef.current;
    v && s.menuState === 0 && v !== (p == null ? void 0 : p.activeElement) && v.focus({ preventScroll: !0 });
  }, [s.menuState, s.itemsRef, p]), Bt({ container: s.itemsRef.current, enabled: s.menuState === 0, accept(v) {
    return v.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : v.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(v) {
    v.setAttribute("role", "none");
  } });
  let b = S((v) => {
    var M, R;
    switch (d.dispose(), v.key) {
      case C.Space:
        if (s.searchQuery !== "")
          return v.preventDefault(), v.stopPropagation(), c({ type: 3, value: v.key });
      case C.Enter:
        if (v.preventDefault(), v.stopPropagation(), c({ type: 1 }), s.activeItemIndex !== null) {
          let { dataRef: E } = s.items[s.activeItemIndex];
          (R = (M = E.current) == null ? void 0 : M.domRef.current) == null || R.click();
        }
        kr(s.buttonRef.current);
        break;
      case C.ArrowDown:
        return v.preventDefault(), v.stopPropagation(), c({ type: 2, focus: A.Next });
      case C.ArrowUp:
        return v.preventDefault(), v.stopPropagation(), c({ type: 2, focus: A.Previous });
      case C.Home:
      case C.PageUp:
        return v.preventDefault(), v.stopPropagation(), c({ type: 2, focus: A.First });
      case C.End:
      case C.PageDown:
        return v.preventDefault(), v.stopPropagation(), c({ type: 2, focus: A.Last });
      case C.Escape:
        v.preventDefault(), v.stopPropagation(), c({ type: 1 }), ce().nextFrame(() => {
          var E;
          return (E = s.buttonRef.current) == null ? void 0 : E.focus({ preventScroll: !0 });
        });
        break;
      case C.Tab:
        v.preventDefault(), v.stopPropagation(), c({ type: 1 }), ce().nextFrame(() => {
          bl(s.buttonRef.current, v.shiftKey ? Ee.Previous : Ee.Next);
        });
        break;
      default:
        v.key.length === 1 && (c({ type: 3, value: v.key }), d.setTimeout(() => c({ type: 4 }), 350));
        break;
    }
  }), g = S((v) => {
    switch (v.key) {
      case C.Space:
        v.preventDefault();
        break;
    }
  }), y = j(() => ({ open: s.menuState === 0 }), [s]), w = { "aria-activedescendant": s.activeItemIndex === null || (r = s.items[s.activeItemIndex]) == null ? void 0 : r.id, "aria-labelledby": (n = s.buttonRef.current) == null ? void 0 : n.id, id: i, onKeyDown: b, onKeyUp: g, role: "menu", tabIndex: 0, ref: u };
  return W({ ourProps: w, theirProps: a, slot: y, defaultTag: Lo, features: Po, visible: f, name: "Menu.Items" });
}
let Do = ae;
function Ao(e, t) {
  let r = oe(), { id: n = `headlessui-menu-item-${r}`, disabled: l = !1, ...i } = e, [a, s] = dt("Menu.Item"), c = a.activeItemIndex !== null ? a.items[a.activeItemIndex].id === n : !1, u = L(null), p = ee(t, u);
  z(() => {
    if (a.menuState !== 0 || !c || a.activationTrigger === 0)
      return;
    let R = ce();
    return R.requestAnimationFrame(() => {
      var E, I;
      (I = (E = u.current) == null ? void 0 : E.scrollIntoView) == null || I.call(E, { block: "nearest" });
    }), R.dispose;
  }, [u, c, a.menuState, a.activationTrigger, a.activeItemIndex]);
  let d = L({ disabled: l, domRef: u });
  z(() => {
    d.current.disabled = l;
  }, [d, l]), z(() => {
    var R, E;
    d.current.textValue = (E = (R = u.current) == null ? void 0 : R.textContent) == null ? void 0 : E.toLowerCase();
  }, [d, u]), z(() => (s({ type: 5, id: n, dataRef: d }), () => s({ type: 6, id: n })), [d, n]);
  let m = S(() => {
    s({ type: 1 });
  }), f = S((R) => {
    if (l)
      return R.preventDefault();
    s({ type: 1 }), kr(a.buttonRef.current);
  }), b = S(() => {
    if (l)
      return s({ type: 2, focus: A.Nothing });
    s({ type: 2, focus: A.Specific, id: n });
  }), g = Vt(), y = S((R) => g.update(R)), w = S((R) => {
    g.wasMoved(R) && (l || c || s({ type: 2, focus: A.Specific, id: n, trigger: 0 }));
  }), v = S((R) => {
    g.wasMoved(R) && (l || c && s({ type: 2, focus: A.Nothing }));
  }), M = j(() => ({ active: c, disabled: l, close: m }), [c, l, m]);
  return W({ ourProps: { id: n, ref: p, role: "menuitem", tabIndex: l === !0 ? void 0 : -1, "aria-disabled": l === !0 ? !0 : void 0, disabled: void 0, onClick: f, onFocus: b, onPointerEnter: y, onMouseEnter: y, onPointerMove: w, onMouseMove: w, onPointerLeave: v, onMouseLeave: v }, theirProps: i, slot: M, defaultTag: Do, name: "Menu.Item" });
}
let Mo = X(Ro), _o = X($o), jo = X(Fo), Bo = X(Ao), Le = Object.assign(Mo, { Button: _o, Items: jo, Item: Bo });
function Dr(e = 0) {
  let [t, r] = H(e), n = Kt(), l = Re((c) => {
    n.current && r((u) => u | c);
  }, [t, n]), i = Re((c) => Boolean(t & c), [t]), a = Re((c) => {
    n.current && r((u) => u & ~c);
  }, [r, n]), s = Re((c) => {
    n.current && r((u) => u ^ c);
  }, [r]);
  return { flags: t, addFlag: l, hasFlag: i, removeFlag: a, toggleFlag: s };
}
let Ar = ue(null);
function Mr() {
  let e = ie(Ar);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, Mr), t;
  }
  return e;
}
function Yt() {
  let [e, t] = H([]);
  return [e.length > 0 ? e.join(" ") : void 0, j(() => function(r) {
    let n = S((i) => (t((a) => [...a, i]), () => t((a) => {
      let s = a.slice(), c = s.indexOf(i);
      return c !== -1 && s.splice(c, 1), s;
    }))), l = j(() => ({ register: n, slot: r.slot, name: r.name, props: r.props }), [n, r.slot, r.name, r.props]);
    return _.createElement(Ar.Provider, { value: l }, r.children);
  }, [t])];
}
let Ho = "label";
function Go(e, t) {
  let r = oe(), { id: n = `headlessui-label-${r}`, passive: l = !1, ...i } = e, a = Mr(), s = ee(t);
  z(() => a.register(n), [n, a.register]);
  let c = { ref: s, ...a.props, id: n };
  return l && ("onClick" in c && (delete c.htmlFor, delete c.onClick), "onClick" in i && delete i.onClick), W({ ourProps: c, theirProps: i, slot: a.slot || {}, defaultTag: Ho, name: a.name || "Label" });
}
let Vo = X(Go), _r = Object.assign(Vo, {});
var Uo = ((e) => (e[e.RegisterOption = 0] = "RegisterOption", e[e.UnregisterOption = 1] = "UnregisterOption", e))(Uo || {});
let zo = { [0](e, t) {
  let r = [...e.options, { id: t.id, element: t.element, propsRef: t.propsRef }];
  return { ...e, options: Ue(r, (n) => n.element.current) };
}, [1](e, t) {
  let r = e.options.slice(), n = e.options.findIndex((l) => l.id === t.id);
  return n === -1 ? e : (r.splice(n, 1), { ...e, options: r });
} }, Jt = ue(null);
Jt.displayName = "RadioGroupDataContext";
function jr(e) {
  let t = ie(Jt);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, jr), r;
  }
  return t;
}
let Zt = ue(null);
Zt.displayName = "RadioGroupActionsContext";
function Br(e) {
  let t = ie(Zt);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Br), r;
  }
  return t;
}
function Ko(e, t) {
  return K(t.type, zo, e, t);
}
let qo = "div";
function Wo(e, t) {
  let r = oe(), { id: n = `headlessui-radiogroup-${r}`, value: l, defaultValue: i, form: a, name: s, onChange: c, by: u = (F, J) => F === J, disabled: p = !1, ...d } = e, m = S(typeof u == "string" ? (F, J) => {
    let V = u;
    return (F == null ? void 0 : F[V]) === (J == null ? void 0 : J[V]);
  } : u), [f, b] = Je(Ko, { options: [] }), g = f.options, [y, w] = Yt(), [v, M] = qt(), R = L(null), E = ee(R, t), [I, N] = ut(l, c, i), D = j(() => g.find((F) => !F.propsRef.current.disabled), [g]), k = j(() => g.some((F) => m(F.propsRef.current.value, I)), [g, I]), G = S((F) => {
    var J;
    if (p || m(F, I))
      return !1;
    let V = (J = g.find((le) => m(le.propsRef.current.value, F))) == null ? void 0 : J.propsRef.current;
    return V != null && V.disabled ? !1 : (N == null || N(F), !0);
  });
  Bt({ container: R.current, accept(F) {
    return F.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : F.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(F) {
    F.setAttribute("role", "none");
  } });
  let P = S((F) => {
    let J = R.current;
    if (!J)
      return;
    let V = Ae(J), le = g.filter((re) => re.propsRef.current.disabled === !1).map((re) => re.element.current);
    switch (F.key) {
      case C.Enter:
        $r(F.currentTarget);
        break;
      case C.ArrowLeft:
      case C.ArrowUp:
        if (F.preventDefault(), F.stopPropagation(), Ct(le, Ee.Previous | Ee.WrapAround) === kt.Success) {
          let re = g.find((O) => O.element.current === (V == null ? void 0 : V.activeElement));
          re && G(re.propsRef.current.value);
        }
        break;
      case C.ArrowRight:
      case C.ArrowDown:
        if (F.preventDefault(), F.stopPropagation(), Ct(le, Ee.Next | Ee.WrapAround) === kt.Success) {
          let re = g.find((O) => O.element.current === (V == null ? void 0 : V.activeElement));
          re && G(re.propsRef.current.value);
        }
        break;
      case C.Space:
        {
          F.preventDefault(), F.stopPropagation();
          let re = g.find((O) => O.element.current === (V == null ? void 0 : V.activeElement));
          re && G(re.propsRef.current.value);
        }
        break;
    }
  }), Q = S((F) => (b({ type: 0, ...F }), () => b({ type: 1, id: F.id }))), Y = j(() => ({ value: I, firstOption: D, containsCheckedOption: k, disabled: p, compare: m, ...f }), [I, D, k, p, m, f]), fe = j(() => ({ registerOption: Q, change: G }), [Q, G]), se = { ref: E, id: n, role: "radiogroup", "aria-labelledby": y, "aria-describedby": v, onKeyDown: P }, he = j(() => ({ value: I }), [I]), ne = L(null), ve = de();
  return U(() => {
    ne.current && i !== void 0 && ve.addEventListener(ne.current, "reset", () => {
      G(i);
    });
  }, [ne, G]), _.createElement(M, { name: "RadioGroup.Description" }, _.createElement(w, { name: "RadioGroup.Label" }, _.createElement(Zt.Provider, { value: fe }, _.createElement(Jt.Provider, { value: Y }, s != null && I != null && it({ [s]: I }).map(([F, J], V) => _.createElement(st, { features: ze.Hidden, ref: V === 0 ? (le) => {
    var re;
    ne.current = (re = le == null ? void 0 : le.closest("form")) != null ? re : null;
  } : void 0, ...Fe({ key: F, as: "input", type: "radio", checked: J != null, hidden: !0, readOnly: !0, form: a, name: F, value: J }) })), W({ ourProps: se, theirProps: d, slot: he, defaultTag: qo, name: "RadioGroup" })))));
}
var Xo = ((e) => (e[e.Empty = 1] = "Empty", e[e.Active = 2] = "Active", e))(Xo || {});
let Qo = "div";
function Yo(e, t) {
  var r;
  let n = oe(), { id: l = `headlessui-radiogroup-option-${n}`, value: i, disabled: a = !1, ...s } = e, c = L(null), u = ee(c, t), [p, d] = Yt(), [m, f] = qt(), { addFlag: b, removeFlag: g, hasFlag: y } = Dr(1), w = be({ value: i, disabled: a }), v = jr("RadioGroup.Option"), M = Br("RadioGroup.Option");
  z(() => M.registerOption({ id: l, element: c, propsRef: w }), [l, M, c, e]);
  let R = S((Q) => {
    var Y;
    if (De(Q.currentTarget))
      return Q.preventDefault();
    M.change(i) && (b(2), (Y = c.current) == null || Y.focus());
  }), E = S((Q) => {
    if (De(Q.currentTarget))
      return Q.preventDefault();
    b(2);
  }), I = S(() => g(2)), N = ((r = v.firstOption) == null ? void 0 : r.id) === l, D = v.disabled || a, k = v.compare(v.value, i), G = { ref: u, id: l, role: "radio", "aria-checked": k ? "true" : "false", "aria-labelledby": p, "aria-describedby": m, "aria-disabled": D ? !0 : void 0, tabIndex: (() => D ? -1 : k || !v.containsCheckedOption && N ? 0 : -1)(), onClick: D ? void 0 : R, onFocus: D ? void 0 : E, onBlur: D ? void 0 : I }, P = j(() => ({ checked: k, disabled: D, active: y(2) }), [k, D, y]);
  return _.createElement(f, { name: "RadioGroup.Description" }, _.createElement(d, { name: "RadioGroup.Label" }, W({ ourProps: G, theirProps: s, slot: P, defaultTag: Qo, name: "RadioGroup.Option" })));
}
let Jo = X(Wo), Zo = X(Yo), Se = Object.assign(Jo, { Option: Zo, Label: _r, Description: Fr }), er = ue(null);
er.displayName = "GroupContext";
let ea = ae;
function ta(e) {
  var t;
  let [r, n] = H(null), [l, i] = Yt(), [a, s] = qt(), c = j(() => ({ switch: r, setSwitch: n, labelledby: l, describedby: a }), [r, n, l, a]), u = {}, p = e;
  return _.createElement(s, { name: "Switch.Description" }, _.createElement(i, { name: "Switch.Label", props: { htmlFor: (t = c.switch) == null ? void 0 : t.id, onClick(d) {
    r && (d.currentTarget.tagName === "LABEL" && d.preventDefault(), r.click(), r.focus({ preventScroll: !0 }));
  } } }, _.createElement(er.Provider, { value: c }, W({ ourProps: u, theirProps: p, defaultTag: ea, name: "Switch.Group" }))));
}
let ra = "button";
function na(e, t) {
  let r = oe(), { id: n = `headlessui-switch-${r}`, checked: l, defaultChecked: i = !1, onChange: a, name: s, value: c, form: u, ...p } = e, d = ie(er), m = L(null), f = ee(m, t, d === null ? null : d.setSwitch), [b, g] = ut(l, a, i), y = S(() => g == null ? void 0 : g(!b)), w = S((N) => {
    if (De(N.currentTarget))
      return N.preventDefault();
    N.preventDefault(), y();
  }), v = S((N) => {
    N.key === C.Space ? (N.preventDefault(), y()) : N.key === C.Enter && $r(N.currentTarget);
  }), M = S((N) => N.preventDefault()), R = j(() => ({ checked: b }), [b]), E = { id: n, ref: f, role: "switch", type: at(e, m), tabIndex: 0, "aria-checked": b, "aria-labelledby": d == null ? void 0 : d.labelledby, "aria-describedby": d == null ? void 0 : d.describedby, onClick: w, onKeyUp: v, onKeyPress: M }, I = de();
  return U(() => {
    var N;
    let D = (N = m.current) == null ? void 0 : N.closest("form");
    D && i !== void 0 && I.addEventListener(D, "reset", () => {
      g(i);
    });
  }, [m, g]), _.createElement(_.Fragment, null, s != null && b && _.createElement(st, { features: ze.Hidden, ...Fe({ as: "input", type: "checkbox", hidden: !0, readOnly: !0, form: u, checked: b, name: s, value: c }) }), W({ ourProps: E, theirProps: p, slot: R, defaultTag: ra, name: "Switch" }));
}
let la = X(na), oa = ta, aa = Object.assign(la, { Group: oa, Label: _r, Description: Fr });
function ia(e) {
  let t = { called: !1 };
  return (...r) => {
    if (!t.called)
      return t.called = !0, e(...r);
  };
}
function wt(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function Nt(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
function sa(e, t) {
  let r = ce();
  if (!e)
    return r.dispose;
  let { transitionDuration: n, transitionDelay: l } = getComputedStyle(e), [i, a] = [n, l].map((c) => {
    let [u = 0] = c.split(",").filter(Boolean).map((p) => p.includes("ms") ? parseFloat(p) : parseFloat(p) * 1e3).sort((p, d) => d - p);
    return u;
  }), s = i + a;
  if (s !== 0) {
    r.group((u) => {
      u.setTimeout(() => {
        t(), u.dispose();
      }, s), u.addEventListener(e, "transitionrun", (p) => {
        p.target === p.currentTarget && u.dispose();
      });
    });
    let c = r.addEventListener(e, "transitionend", (u) => {
      u.target === u.currentTarget && (t(), c());
    });
  } else
    t();
  return r.add(() => t()), r.dispose;
}
function ca(e, t, r, n) {
  let l = r ? "enter" : "leave", i = ce(), a = n !== void 0 ? ia(n) : () => {
  };
  l === "enter" && (e.removeAttribute("hidden"), e.style.display = "");
  let s = K(l, { enter: () => t.enter, leave: () => t.leave }), c = K(l, { enter: () => t.enterTo, leave: () => t.leaveTo }), u = K(l, { enter: () => t.enterFrom, leave: () => t.leaveFrom });
  return Nt(e, ...t.enter, ...t.enterTo, ...t.enterFrom, ...t.leave, ...t.leaveFrom, ...t.leaveTo, ...t.entered), wt(e, ...s, ...u), i.nextFrame(() => {
    Nt(e, ...u), wt(e, ...c), sa(e, () => (Nt(e, ...s), wt(e, ...t.entered), a()));
  }), i.dispose;
}
function ua({ container: e, direction: t, classes: r, onStart: n, onStop: l }) {
  let i = Kt(), a = de(), s = be(t);
  z(() => {
    let c = ce();
    a.add(c.dispose);
    let u = e.current;
    if (u && s.current !== "idle" && i.current)
      return c.dispose(), n.current(s.current), c.add(ca(u, r.current, s.current === "enter", () => {
        c.dispose(), l.current(s.current);
      })), c.dispose;
  }, [t]);
}
function Ce(e = "") {
  return e.split(" ").filter((t) => t.trim().length > 1);
}
let pt = ue(null);
pt.displayName = "TransitionContext";
var da = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(da || {});
function pa() {
  let e = ie(pt);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
function ma() {
  let e = ie(mt);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
let mt = ue(null);
mt.displayName = "NestingContext";
function ft(e) {
  return "children" in e ? ft(e.children) : e.current.filter(({ el: t }) => t.current !== null).filter(({ state: t }) => t === "visible").length > 0;
}
function Hr(e, t) {
  let r = be(e), n = L([]), l = Kt(), i = de(), a = S((f, b = we.Hidden) => {
    let g = n.current.findIndex(({ el: y }) => y === f);
    g !== -1 && (K(b, { [we.Unmount]() {
      n.current.splice(g, 1);
    }, [we.Hidden]() {
      n.current[g].state = "hidden";
    } }), i.microTask(() => {
      var y;
      !ft(n) && l.current && ((y = r.current) == null || y.call(r));
    }));
  }), s = S((f) => {
    let b = n.current.find(({ el: g }) => g === f);
    return b ? b.state !== "visible" && (b.state = "visible") : n.current.push({ el: f, state: "visible" }), () => a(f, we.Unmount);
  }), c = L([]), u = L(Promise.resolve()), p = L({ enter: [], leave: [], idle: [] }), d = S((f, b, g) => {
    c.current.splice(0), t && (t.chains.current[b] = t.chains.current[b].filter(([y]) => y !== f)), t == null || t.chains.current[b].push([f, new Promise((y) => {
      c.current.push(y);
    })]), t == null || t.chains.current[b].push([f, new Promise((y) => {
      Promise.all(p.current[b].map(([w, v]) => v)).then(() => y());
    })]), b === "enter" ? u.current = u.current.then(() => t == null ? void 0 : t.wait.current).then(() => g(b)) : g(b);
  }), m = S((f, b, g) => {
    Promise.all(p.current[b].splice(0).map(([y, w]) => w)).then(() => {
      var y;
      (y = c.current.shift()) == null || y();
    }).then(() => g(b));
  });
  return j(() => ({ children: n, register: s, unregister: a, onStart: d, onStop: m, wait: u, chains: p }), [s, a, n, d, m, p, u]);
}
function fa() {
}
let ba = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function dr(e) {
  var t;
  let r = {};
  for (let n of ba)
    r[n] = (t = e[n]) != null ? t : fa;
  return r;
}
function ga(e) {
  let t = L(dr(e));
  return U(() => {
    t.current = dr(e);
  }, [e]), t;
}
let ha = "div", Gr = Te.RenderStrategy;
function va(e, t) {
  let { beforeEnter: r, afterEnter: n, beforeLeave: l, afterLeave: i, enter: a, enterFrom: s, enterTo: c, entered: u, leave: p, leaveFrom: d, leaveTo: m, ...f } = e, b = L(null), g = ee(b, t), y = f.unmount ? we.Unmount : we.Hidden, { show: w, appear: v, initial: M } = pa(), [R, E] = H(w ? "visible" : "hidden"), I = ma(), { register: N, unregister: D } = I, k = L(null);
  U(() => N(b), [N, b]), U(() => {
    if (y === we.Hidden && b.current) {
      if (w && R !== "visible") {
        E("visible");
        return;
      }
      return K(R, { hidden: () => D(b), visible: () => N(b) });
    }
  }, [R, b, N, D, w, y]);
  let G = be({ enter: Ce(a), enterFrom: Ce(s), enterTo: Ce(c), entered: Ce(u), leave: Ce(p), leaveFrom: Ce(d), leaveTo: Ce(m) }), P = ga({ beforeEnter: r, afterEnter: n, beforeLeave: l, afterLeave: i }), Q = _t();
  U(() => {
    if (Q && R === "visible" && b.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [b, R, Q]);
  let Y = M && !v, fe = (() => !Q || Y || k.current === w ? "idle" : w ? "enter" : "leave")(), se = Dr(0), he = S((V) => K(V, { enter: () => {
    se.addFlag(Z.Opening), P.current.beforeEnter();
  }, leave: () => {
    se.addFlag(Z.Closing), P.current.beforeLeave();
  }, idle: () => {
  } })), ne = S((V) => K(V, { enter: () => {
    se.removeFlag(Z.Opening), P.current.afterEnter();
  }, leave: () => {
    se.removeFlag(Z.Closing), P.current.afterLeave();
  }, idle: () => {
  } })), ve = Hr(() => {
    E("hidden"), D(b);
  }, I);
  ua({ container: b, classes: G, direction: fe, onStart: be((V) => {
    ve.onStart(b, V, he);
  }), onStop: be((V) => {
    ve.onStop(b, V, ne), V === "leave" && !ft(ve) && (E("hidden"), D(b));
  }) }), U(() => {
    Y && (y === we.Hidden ? k.current = null : k.current = w);
  }, [w, Y, R]);
  let F = f, J = { ref: g };
  return v && w && (F = { ...F, className: Rt(f.className, ...G.current.enter, ...G.current.enterFrom) }), _.createElement(mt.Provider, { value: ve }, _.createElement(ct, { value: K(R, { visible: Z.Open, hidden: Z.Closed }) | se.flags }, W({ ourProps: J, theirProps: F, defaultTag: ha, features: Gr, visible: R === "visible", name: "Transition.Child" })));
}
function xa(e, t) {
  let { show: r, appear: n = !1, unmount: l, ...i } = e, a = L(null), s = ee(a, t);
  _t();
  let c = Ke();
  if (r === void 0 && c !== null && (r = (c & Z.Open) === Z.Open), ![!0, !1].includes(r))
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [u, p] = H(r ? "visible" : "hidden"), d = Hr(() => {
    p("hidden");
  }), [m, f] = H(!0), b = L([r]);
  z(() => {
    m !== !1 && b.current[b.current.length - 1] !== r && (b.current.push(r), f(!1));
  }, [b, r]);
  let g = j(() => ({ show: r, appear: n, initial: m }), [r, n, m]);
  U(() => {
    if (r)
      p("visible");
    else if (!ft(d))
      p("hidden");
    else {
      let w = a.current;
      if (!w)
        return;
      let v = w.getBoundingClientRect();
      v.x === 0 && v.y === 0 && v.width === 0 && v.height === 0 && p("hidden");
    }
  }, [r, d]);
  let y = { unmount: l };
  return _.createElement(mt.Provider, { value: d }, _.createElement(pt.Provider, { value: g }, W({ ourProps: { ...y, as: ae, children: _.createElement(Vr, { ref: s, ...y, ...i }) }, theirProps: {}, defaultTag: ae, features: Gr, visible: u === "visible", name: "Transition" })));
}
function ya(e, t) {
  let r = ie(pt) !== null, n = Ke() !== null;
  return _.createElement(_.Fragment, null, !r && n ? _.createElement(Et, { ref: t, ...e }) : _.createElement(Vr, { ref: t, ...e }));
}
let Et = X(xa), Vr = X(va), wa = X(ya), tr = Object.assign(Et, { Child: wa, Root: Et });
const Na = ({
  checked: e = !1,
  disabled: t = !1,
  onChange: r
}) => /* @__PURE__ */ o(
  aa,
  {
    checked: e,
    className: x([
      "group h-6 w-12 shrink-0 rounded-full p-px",
      "transition-colors",
      "outline-4 outline-offset-1 focus-visible:outline-primary-02",
      t && "cursor-not-allowed",
      t ? e ? "bg-secondary-01" : "bg-grey-02" : e ? "bg-secondary-04" : "bg-grey-04"
    ]),
    disabled: t,
    onChange: r,
    children: /* @__PURE__ */ o(
      "div",
      {
        className: x([
          "flex items-center justify-center ",
          "h-5.5 w-5.5 rounded-full transition",
          e ? "translate-x-6" : "translate-x-0",
          t ? e ? "bg-white" : "bg-grey-03" : e ? "bg-white drop-shadow-[-1px_0_4px_rgba(0,0,0,0.15)]" : "bg-grey-02 drop-shadow-[1px_0_2px_rgba(0,0,0,0.15)]"
        ]),
        children: /* @__PURE__ */ o(
          "div",
          {
            className: x([
              "h-3.5 w-3.5 rounded-full transition",
              t ? e ? "bg-grey-01" : "bg-grey-02" : e ? "group-hover:bg-grey-02" : "group-hover:bg-white",
              !t && "bg-grey-01"
            ])
          }
        )
      }
    )
  }
), ns = ({ children: e, value: t, onChange: r, labelTitle: n, labelSubtitle: l }) => /* @__PURE__ */ h("div", { className: "flex w-full flex-col gap-6 rounded-lg border border-grey-02 bg-white py-4 px-5 hover:border-grey-03", children: [
  /* @__PURE__ */ h("div", { className: "flex items-center gap-4", children: [
    /* @__PURE__ */ o(Na, { checked: t, onChange: r }),
    /* @__PURE__ */ h("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ o("div", { className: "text-sm", children: n }),
      l && /* @__PURE__ */ o("div", { className: "text-xs text-grey-05", children: l })
    ] })
  ] }),
  t && e && /* @__PURE__ */ o(te, { children: e })
] }), Sa = {
  lg: "h-6 w-6",
  md: "h-5 w-5",
  sm: "h-5 w-5"
}, ge = ({
  Icon: e,
  ariaLabel: t,
  className: r,
  disabled: n,
  name: l,
  onClick: i,
  size: a = "md",
  variant: s = "primary"
}) => /* @__PURE__ */ o(
  Oe,
  {
    name: l,
    className: r,
    containsOnlyIcon: !0,
    disabled: n,
    onClick: i,
    size: a,
    variant: s,
    children: /* @__PURE__ */ o(e, { className: Sa[a], "aria-label": t })
  }
), ls = ({
  children: e,
  disabled: t,
  id: r,
  initiallyOpened: n = !1,
  label: l,
  ...i
}) => {
  const [a, s] = H(n);
  return /* @__PURE__ */ h("div", { className: "rounded-lg border border-grey-02 bg-white hover:border-grey-03", children: [
    /* @__PURE__ */ h("div", { className: "flex h-12 items-center justify-between pl-4.5 pr-2", children: [
      /* @__PURE__ */ h("div", { className: "mr-2 flex items-center", children: [
        /* @__PURE__ */ o(Mt, { disabled: t, id: r, ...i }),
        /* @__PURE__ */ o(Or, { id: r, children: l })
      ] }),
      /* @__PURE__ */ o(
        ge,
        {
          Icon: a ? et : He,
          onClick: () => s(!a),
          variant: "ghost"
        }
      )
    ] }),
    a && /* @__PURE__ */ o("div", { className: "text-grey-07", children: e })
  ] });
}, Oa = (e) => ({ label: t }) => t.toLowerCase().includes(e.toLowerCase()), os = ({
  Icon: e,
  iconClass: t,
  ariaLabelToggle: r = "Toggle Options",
  children: n,
  disabled: l,
  displayValue: i = (b) => b.label,
  hasError: a,
  options: s,
  query: c,
  onChange: u,
  onCommitQuery: p,
  placeholder: d,
  setQuery: m,
  value: f
}) => {
  const [b, g] = H(c || ""), y = b === "" ? s : s.filter(Oa(b));
  return /* @__PURE__ */ o(q, { value: f, onChange: u, disabled: l, children: ({ open: w }) => /* @__PURE__ */ h("div", { children: [
    /* @__PURE__ */ o(
      "div",
      {
        "data-testid": "multiselect-wrapper",
        className: x(
          "flex items-center justify-between",
          "rounded-md border border-solid outline outline-2",
          "min-h-10 w-full px-3 text-base",
          {
            "border-error-04 bg-grey-transparent-01 outline-error-01 hover:bg-white": !l && a && !w,
            "border-error-04 bg-white outline-error-01": !l && a && w,
            "border-grey-03 bg-grey-transparent-02 text-grey-04 outline-transparent": l,
            "border-secondary-04 bg-white outline-secondary-01": !l && !a && w,
            "border-transparent bg-grey-transparent-01 text-grey-08 outline-transparent hover:border-grey-transparent-03 hover:bg-white hover:outline-grey-transparent-01 focus:border-secondary-04 focus:bg-white focus:outline-secondary-01": !l && !a && !w
          }
        ),
        children: /* @__PURE__ */ h("div", { className: "flex w-full flex-wrap items-center", children: [
          e && /* @__PURE__ */ o(e, { className: `mr-2 h-5 w-5 ${t}` }),
          /* @__PURE__ */ o(
            q.Input,
            {
              autoComplete: "false",
              className: "my-1 flex-1 border-0 bg-transparent p-0 text-sm text-grey-08 !ring-0 placeholder:text-grey-04",
              placeholder: d,
              displayValue: i,
              onChange: (v) => m ? m(v.currentTarget.value) : g(v.currentTarget.value),
              onKeyDown: (v) => {
                v.key === "Enter" && c && (p == null || p(c));
              }
            }
          ),
          /* @__PURE__ */ o(
            q.Button,
            {
              "aria-label": r,
              className: "text-grey-07",
              children: /* @__PURE__ */ o(
                tt,
                {
                  className: x(
                    "h-5 w-5",
                    "transition-transform",
                    w && "rotate-180"
                  )
                }
              )
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ o(
      tr,
      {
        as: ae,
        leave: "transition-opacity",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /* @__PURE__ */ o("div", { className: "listbox relative z-10", children: /* @__PURE__ */ o(q.Options, { className: "absolute mt-1 flex max-h-40 w-full cursor-pointer flex-col gap-1 overflow-auto rounded-lg bg-white p-1 drop-shadow-s focus:outline-none", children: y.map((v, M) => /* @__PURE__ */ o(
          q.Option,
          {
            className: ({ active: R }) => x(
              "rounded-md px-3 py-2 text-base text-black",
              R && "bg-grey-transparent-02"
            ),
            value: v,
            children: ({ selected: R }) => /* @__PURE__ */ o(
              "span",
              {
                className: x("block", R && "font-medium"),
                children: n ? n(v) : v.label
              }
            )
          },
          M
        )) }) })
      }
    )
  ] }) });
}, Ta = {
  aqua_light: T`bg-[#DFFBF9] text-[#00726B]`,
  default: T`bg-grey-transparent-02 text-grey-08`,
  document: T`bg-grey-transparent-02`,
  error: T`bg-error-01 text-error-04`,
  primary: T`bg-primary-03 text-grey-10`,
  secondary: T`bg-secondary-01 text-secondary-05`,
  success: T`bg-success-01 text-success-05`,
  tint: T`text-white`,
  type: "",
  warning: T`bg-warning-01 text-warning-04`
}, Ia = {
  blue: T`bg-tint-blue-light text-tint-blue`,
  dark_blue: T`bg-secondary-01 text-secondary-05`,
  green: T`bg-tint-green-light text-tint-green-dark`,
  light_blue: T`bg-tint-aqua-light text-tint-aqua-dark`,
  purple: T`bg-tint-purple-light text-tint-purple-dark`,
  red: T`bg-tint-red-light text-tint-red-dark`,
  yellow: T`bg-primary-01 text-primary-06 `
}, ka = {
  PDF: T`text-tint-red-dark`,
  course: T`text-grey-08`,
  image: T`text-tint-indigo-dark`
}, Ca = {
  lg: T`gap-1.5 px-2.5 text-md`,
  md: T`gap-1 px-2 text-sm`,
  sm: T`gap-0.5 px-1.5 text-xs`
}, Ra = {
  lg: T`mr-1.5`,
  md: T`mr-1`,
  sm: T`mr-0.5`
}, _e = ({
  disabled: e = !1,
  documentType: t = "PDF",
  onRemove: r,
  id: n,
  type: l = "yellow",
  removeButtonLabel: i,
  size: a = "sm",
  title: s,
  variant: c = "default",
  className: u
}) => /* @__PURE__ */ h(
  "div",
  {
    className: Ne(
      x(
        "inline-flex items-center rounded py-0.5 font-medium",
        Ta[c],
        Ca[a],
        !e && r && "pr-0",
        c === "type" && l && Ia[l],
        c === "tint" && n && $t(n),
        c === "document" && ka[t],
        u
      )
    ),
    children: [
      s,
      !e && r && /* @__PURE__ */ o(
        "button",
        {
          "aria-label": i,
          className: Ra[a],
          onClick: r,
          children: /* @__PURE__ */ o(
            un,
            {
              className: x(
                "h-4 w-4",
                "text-grey-transparent-04",
                "hover:text-grey-transparent-06",
                "active:text-grey-transparent-08"
              )
            }
          )
        }
      )
    ]
  }
), Ur = ({
  title: e,
  children: t,
  Image: r,
  Tag: n,
  chapters: l,
  duration: i,
  Actions: a,
  authors: s,
  onClick: c,
  customStyles: u
}) => /* @__PURE__ */ h(me, { className: "group max-w-[264px]", children: [
  /* @__PURE__ */ h("button", { onClick: c, className: "flex flex-col", children: [
    /* @__PURE__ */ o(r, {}),
    /* @__PURE__ */ o(n, {}),
    /* @__PURE__ */ o(me.Title, { customStyles: u, bottomMargin: "sm", children: e }),
    /* @__PURE__ */ o(me.Body, { className: "mb-3 line-clamp-3", children: t })
  ] }),
  /* @__PURE__ */ h("div", { className: "flex h-9 items-center gap-3 group-hover:hidden", children: [
    s.length > 0 && /* @__PURE__ */ o(Vn, { children: s.map(({ name: p, id: d, imageSrc: m }) => /* @__PURE__ */ o(Dt, { name: p, id: d, imageSrc: m }, d)) }),
    /* @__PURE__ */ h("span", { className: "align-middle text-sm text-grey-04", children: [
      /* @__PURE__ */ o(gr, { className: "inline h-5 w-5" }),
      " ",
      l
    ] }),
    /* @__PURE__ */ h("span", { className: "align-middle text-sm text-grey-04", children: [
      /* @__PURE__ */ o(hr, { className: "inline h-5 w-5" }),
      " ",
      i
    ] })
  ] }),
  /* @__PURE__ */ o("div", { className: "hidden h-9 gap-2 group-hover:flex", children: /* @__PURE__ */ o(a, {}) })
] }), Ea = ({ src: e, alt: t }) => /* @__PURE__ */ h("div", { className: "relative mb-2 overflow-hidden rounded-lg ", children: [
  /* @__PURE__ */ o(
    "img",
    {
      alt: t,
      src: e,
      className: "h-[140px] w-[264px] rounded-lg object-cover object-center transition-transform duration-500 group-hover:scale-105"
    }
  ),
  /* @__PURE__ */ o("div", { className: "absolute inset-0 h-full w-full rounded-lg group-hover:backdrop-blur-sm" }),
  /* @__PURE__ */ o("span", { className: "absolute inset-0 hidden items-center justify-center group-hover:flex", children: /* @__PURE__ */ o("span", { className: "rounded-md bg-grey-01 p-1 text-grey-09", children: /* @__PURE__ */ o(dn, { className: "h-5 w-5 " }) }) })
] }), $a = ({
  title: e,
  variant: t = "default"
}) => /* @__PURE__ */ o("div", { className: "mb-3", children: /* @__PURE__ */ o(_e, { title: e, variant: t }) });
Ur.Image = Ea;
Ur.Tag = $a;
const as = ({
  children: e,
  Icon: t,
  imageNode: r,
  imageUrl: n,
  title: l,
  to: i
}) => /* @__PURE__ */ h(
  Ie,
  {
    className: x(
      "group flex min-h-16 w-full items-center bg-white py-1 pl-1 pr-4",
      "rounded-lg text-left text-sm font-medium text-black"
    ),
    to: i,
    children: [
      !!n && /* @__PURE__ */ o("div", { className: "flex h-14 w-18 justify-center overflow-hidden rounded bg-grey-01", children: /* @__PURE__ */ o("img", { className: "h-full max-w-none", src: n }) }),
      !!r && /* @__PURE__ */ o("div", { className: "flex h-14 w-18 items-center justify-center rounded bg-tint-indigo text-grey-03", children: r }),
      t && !n && !r && /* @__PURE__ */ o("div", { className: "flex h-14 w-18 items-center justify-center rounded bg-tint-indigo text-grey-03", children: /* @__PURE__ */ o(t, { className: "h-8 w-8" }) }),
      /* @__PURE__ */ h("div", { className: "flex-1 px-3", children: [
        /* @__PURE__ */ o("p", { className: x(e && "mb-1"), children: l }),
        e
      ] }),
      /* @__PURE__ */ o(pn, { className: "h-5 w-5 text-white group-hover:text-grey-05 group-active:text-grey-08" })
    ]
  }
), La = {
  blue: T`bg-tint-blue-light`,
  dark_blue: T`bg-secondary-01`,
  green: T`bg-tint-green-light`,
  light_blue: T`bg-tint-aqua-light`,
  purple: T`bg-tint-purple-light`,
  red: T`bg-tint-red-light`,
  yellow: T`bg-primary-01`
}, Pa = {
  blue: T`text-tint-blue`,
  dark_blue: T`text-secondary-05`,
  green: T`text-tint-green-dark`,
  light_blue: T`text-tint-aqua`,
  purple: T`text-tint-purple-dark`,
  red: T`text-tint-red-dark`,
  yellow: T`text-primary-06`
}, Fa = {
  large_lg: T`h-8 w-8`,
  large_md: T`h-8 w-8`,
  large_sm: T`h-8 w-8`,
  large_xl: T`h-8 w-8`,
  small_lg: T`h-8 w-8`,
  small_md: T`h-6 w-6`,
  small_sm: T`h-6 w-6`,
  small_xl: T`h-8 w-8`
}, Da = {
  large_lg: T`px-6 py-4`,
  large_md: T`px-4 py-3`,
  large_sm: T`px-3 py-2`,
  large_xl: T`px-8 py-6`,
  small_lg: T`p-4`,
  small_md: T`p-3`,
  small_sm: T`p-2`,
  small_xl: T`p-6`
}, Aa = {
  large_lg: T`h-16 w-20`,
  large_md: T`h-14 w-16`,
  large_sm: T`h-12 w-14`,
  large_xl: T`h-20 w-24`,
  small_lg: T`h-16 w-16`,
  small_md: T`h-12 w-12`,
  small_sm: T`h-10 w-10`,
  small_xl: T`h-20 w-20`
}, zr = ({
  Icon: e = Ft,
  className: t,
  color: r = "green",
  size: n = "small_lg",
  imageUrl: l
}) => /* @__PURE__ */ o(
  "div",
  {
    className: x(
      "rounded",
      !l && La[r],
      !l && Da[n]
    ),
    children: l ? /* @__PURE__ */ o(
      "div",
      {
        className: x("overflow-hidden rounded", Aa[n]),
        children: /* @__PURE__ */ o("img", { src: l, className: "h-full w-full object-cover" })
      }
    ) : /* @__PURE__ */ o(
      e,
      {
        className: x(
          "h-6 w-6",
          Fa[n],
          Pa[r],
          t
        )
      }
    )
  }
), is = ({
  children: e,
  icon: t = Ft,
  className: r,
  classNameIcon: n,
  color: l = "yellow",
  title: i,
  description: a,
  description_btn_more: s = "Show more",
  description_btn_less: c = "Show less",
  helperText: u
}) => {
  const [p, d] = H(!1), [m, f] = H(!1), b = L(null);
  return U(() => {
    if (b.current) {
      const y = parseFloat(
        getComputedStyle(b.current).lineHeight
      ) * 3;
      f(b.current.scrollHeight > y);
    }
  }, [a]), /* @__PURE__ */ h("div", { className: `flex w-full flex-col bg-white p-5 ${r}`, children: [
    /* @__PURE__ */ o("div", { className: "flex", children: /* @__PURE__ */ o(
      zr,
      {
        Icon: t,
        color: l,
        size: "small_sm",
        className: n
      }
    ) }),
    i && /* @__PURE__ */ o("h4", { className: "my-2 text-base", children: i }),
    e && e,
    u && /* @__PURE__ */ o("p", { className: "text-sm text-grey-transparent-05", children: u }),
    (a == null ? void 0 : a.trim()) && /* @__PURE__ */ h("div", { children: [
      /* @__PURE__ */ o(
        "p",
        {
          ref: b,
          style: {
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: p ? "none" : 3,
            display: "-webkit-box",
            overflow: "hidden",
            textOverflow: "ellipsis"
          },
          className: "text-sm text-grey-08",
          dangerouslySetInnerHTML: {
            __html: a
          }
        }
      ),
      m && /* @__PURE__ */ o(
        "div",
        {
          onClick: () => d(!p),
          className: "mt-2 inline-block cursor-pointer text-sm text-tint-blue",
          children: p ? c : s
        }
      )
    ] })
  ] });
}, ss = ({
  blockSize: e = "large",
  icon: t = Ft,
  className: r,
  classNameIcon: n,
  color: l = "yellow",
  iconSize: i = "large_xl",
  imageUrl: a,
  text: s,
  tagTitle: c,
  tagVariant: u,
  tagType: p,
  tagSize: d
}) => /* @__PURE__ */ h(
  "div",
  {
    className: `flex w-full items-center rounded-lg bg-white p-1 ${r}`,
    children: [
      /* @__PURE__ */ o(
        zr,
        {
          Icon: t,
          color: l,
          size: i,
          imageUrl: a,
          className: n
        }
      ),
      /* @__PURE__ */ h("div", { className: "flex flex-1 flex-col gap-2 px-3", children: [
        c && /* @__PURE__ */ o("div", { className: "text-left", children: /* @__PURE__ */ o(
          _e,
          {
            title: c,
            variant: u,
            type: p,
            size: d
          }
        ) }),
        /* @__PURE__ */ o(
          "p",
          {
            className: `max-w-[225px] break-words text-left text-base font-medium text-black line-clamp-2 ${e === "large" ? "text-base" : "text-sm"}`,
            children: s
          }
        )
      ] })
    ]
  }
), cs = ({
  Icon: e,
  count: t,
  title: r,
  to: n
}) => /* @__PURE__ */ h(
  Ie,
  {
    className: "relative flex grow flex-col items-center gap-1.5 rounded-lg bg-grey-01 px-3 py-3.5 active:bg-grey-02",
    to: n,
    children: [
      /* @__PURE__ */ o(e, { className: "h-6 w-6 fill-black text-black" }),
      /* @__PURE__ */ o("span", { className: "text-2xs text-grey-07", children: r }),
      t && /* @__PURE__ */ o("div", { className: "text-xs-medium absolute -top-0.5 -right-0.5 flex items-center justify-center rounded bg-tint-red py-0.5 px-1.5 text-white", children: t })
    ]
  }
), Ma = ({ children: e }) => /* @__PURE__ */ o("dt", { className: "text-sm-medium mr-8 text-grey-08", children: e }), _a = ({ children: e }) => /* @__PURE__ */ o("dd", { className: "text-sm text-grey-06", children: e }), ja = ({ children: e }) => /* @__PURE__ */ o("div", { className: "grid auto-rows-min grid-cols-2 gap-y-2", children: e }), rr = ({
  children: e
}) => /* @__PURE__ */ o("dl", { className: "flex", children: e });
rr.Column = ja;
rr.Term = Ma;
rr.Description = _a;
Nr.setAppElement("body");
const Pe = ({
  isOpen: e,
  children: t,
  className: r
}) => /* @__PURE__ */ o(
  Nr,
  {
    isOpen: e,
    className: "m-auto my-8 max-w-[800px] rounded-xl outline-none " + r,
    overlayClassName: "",
    style: { overlay: { zIndex: 200 } },
    children: /* @__PURE__ */ o("div", { className: "w-full rounded-xl bg-white drop-shadow-m", children: t })
  }
), Ba = ({
  Actions: e,
  children: t,
  closeButtonLabel: r,
  hasBackButton: n = !1,
  onClose: l
}) => /* @__PURE__ */ h(
  "div",
  {
    className: x([
      "text-sm-semibold flex items-center justify-between border-b border-solid border-grey-02 py-2",
      n ? "px-2" : "pl-6 pr-2"
    ]),
    children: [
      t,
      /* @__PURE__ */ h("div", { className: "flex gap-2", children: [
        e && /* @__PURE__ */ o(e, {}),
        /* @__PURE__ */ o(
          ge,
          {
            Icon: rt,
            variant: "ghost",
            onClick: l,
            ariaLabel: r
          }
        )
      ] })
    ]
  }
), Ha = ({ children: e }) => {
  const [t, r] = H(!0);
  return U(() => {
    new window.IntersectionObserver(
      (l) => {
        r(l[0].isIntersecting);
      },
      {
        root: document.querySelector("#modal-body-container"),
        threshold: 1
      }
    ).observe(
      document.querySelector("#modal-body-end-marker")
    );
  }, []), /* @__PURE__ */ h(
    "div",
    {
      id: "modal-body-container",
      className: x(
        "max-h-[75vh] p-6",
        !t && "border-b border-grey-02"
      ),
      children: [
        e,
        /* @__PURE__ */ o("span", { id: "modal-body-end-marker" })
      ]
    }
  );
}, Ga = ({
  children: e,
  onCancel: t,
  cancelButtonLabel: r
}) => /* @__PURE__ */ h(
  "div",
  {
    className: x(
      "flex p-6 pt-4",
      t ? "justify-between" : "justify-end"
    ),
    children: [
      t && /* @__PURE__ */ o(Oe, { variant: "ghost", onClick: t, children: r }),
      e
    ]
  }
);
Pe.Header = Ba;
Pe.Body = Ha;
Pe.Footer = Ga;
const Va = ({
  alt: e,
  closePreviewButtonLabel: t,
  onClose: r,
  showPreview: n,
  src: l,
  title: i
}) => /* @__PURE__ */ h(Pe, { isOpen: n, children: [
  /* @__PURE__ */ o(Pe.Header, { onClose: r, closeButtonLabel: t, children: i }),
  /* @__PURE__ */ o(Pe.Body, { children: /* @__PURE__ */ o("img", { className: "mx-auto h-[65vh]", src: l, alt: e }) })
] }), Ua = ({
  alt: e,
  closePreviewButtonLabel: t,
  onClose: r,
  showPreview: n,
  src: l
}) => n ? /* @__PURE__ */ h("div", { className: "fixed top-0 left-0 flex h-screen w-screen flex-col justify-center bg-black", children: [
  /* @__PURE__ */ o("img", { src: l, alt: e }),
  /* @__PURE__ */ o(
    "div",
    {
      id: "overlay",
      className: "absolute top-0 left-0 h-32 w-screen bg-gradient-to-b from-black/40 to-transparent"
    }
  ),
  /* @__PURE__ */ o("div", { className: "fixed top-11 left-5", children: /* @__PURE__ */ o(
    ge,
    {
      variant: "dark-outline",
      Icon: vr,
      onClick: r,
      ariaLabel: t
    }
  ) })
] }) : /* @__PURE__ */ o(te, {}), za = ({
  alt: e,
  className: t,
  closePreviewButtonLabel: r,
  src: n,
  title: l
}) => {
  const i = Ze(), [a, s] = H(!1);
  return /* @__PURE__ */ h(te, { children: [
    /* @__PURE__ */ o("button", { onClick: () => s(!0), children: /* @__PURE__ */ o("img", { alt: e, src: n, className: t }) }),
    i ? /* @__PURE__ */ o(
      Ua,
      {
        alt: e,
        closePreviewButtonLabel: r,
        onClose: () => s(!1),
        showPreview: a,
        src: n
      }
    ) : /* @__PURE__ */ o(
      Va,
      {
        alt: e,
        closePreviewButtonLabel: r,
        onClose: () => s(!1),
        showPreview: a,
        src: n,
        title: l
      }
    )
  ] });
}, Kr = ({
  Icon: e,
  ariaLabel: t,
  disabled: r,
  size: n,
  variant: l,
  ...i
}) => /* @__PURE__ */ o(Ie, { ...i, children: /* @__PURE__ */ o(
  ge,
  {
    Icon: e,
    ariaLabel: t,
    disabled: r,
    size: n,
    variant: l
  }
) }), Ka = {
  grey: "bg-grey-01",
  white: "bg-white"
}, qa = ({
  children: e,
  rounded: t = "lg",
  background: r = "white",
  className: n
}) => /* @__PURE__ */ o(
  "div",
  {
    className: x(
      n,
      "border border-grey-02",
      t === "lg" ? "rounded-lg" : "rounded-xl",
      Ka[r]
    ),
    children: e
  }
), Wa = {
  PDF: T`p-4 border-error-02 bg-error-01`,
  course: T`p-4 border-secondary-02 bg-secondary-01`,
  image: T`border-tint-indigo`
}, Xa = {
  PDF: /* @__PURE__ */ o(fn, { className: "h-8 w-8 text-error-05" }),
  course: /* @__PURE__ */ o(bn, { className: "h-8 w-8 fill-secondary-04 text-secondary-04" }),
  image: /* @__PURE__ */ o(te, {})
}, us = ({
  collapseButtonLabel: e,
  children: t,
  documentType: r,
  documentTypeTagTitle: n,
  downloadButtonLabel: l,
  downloadUrl: i,
  imageSrc: a,
  imageAlt: s,
  title: c
}) => {
  const [u, p] = H(!1), d = Ze(), m = !!i && !d, f = !!i && d && r !== "course", b = !!i && d && r === "course", g = r === "course", y = {
    download: !0,
    reloadDocument: !0,
    size: "md",
    to: i,
    variant: "outline"
  };
  return /* @__PURE__ */ h(qa, { children: [
    /* @__PURE__ */ h("div", { className: "flex items-center gap-2 p-3 pr-4", children: [
      /* @__PURE__ */ o(
        "div",
        {
          className: x(
            "h-16 w-16 overflow-hidden rounded border",
            Wa[r]
          ),
          children: r === "image" ? /* @__PURE__ */ o(
            za,
            {
              src: a,
              alt: s,
              className: "h-16 w-16 object-cover"
            }
          ) : Xa[r]
        }
      ),
      /* @__PURE__ */ h("div", { className: "flex grow flex-col gap-1", children: [
        /* @__PURE__ */ o("span", { className: "text-base-medium", children: c }),
        /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(
          _e,
          {
            documentType: r,
            title: n,
            variant: "document"
          }
        ) })
      ] }),
      /* @__PURE__ */ h("div", { className: "align-end flex h-9 gap-4", children: [
        m && /* @__PURE__ */ o(Tt, { ...y, children: l }),
        f && /* @__PURE__ */ o(
          Kr,
          {
            ...y,
            ariaLabel: l,
            Icon: mn,
            children: l
          }
        ),
        g && /* @__PURE__ */ o(
          ge,
          {
            ariaLabel: e,
            Icon: u ? et : He,
            onClick: () => p(!u),
            variant: "ghost"
          }
        )
      ] })
    ] }),
    u && /* @__PURE__ */ h("div", { className: "flex items-center gap-2 p-3 pr-4", children: [
      /* @__PURE__ */ o("div", { className: "min-w-16" }),
      /* @__PURE__ */ h("div", { children: [
        t,
        b && /* @__PURE__ */ o(Tt, { ...y, children: l })
      ] })
    ] })
  ] });
}, pe = ({
  children: e
}) => /* @__PURE__ */ o(Le, { as: "div", className: "relative inline-block", children: e }), Qa = ({ children: e, className: t, ref: r }) => /* @__PURE__ */ o(Le.Button, { className: t, ref: r, children: e }), Ya = ({ children: e, ...t }) => /* @__PURE__ */ o(
  Le.Items,
  {
    className: x([
      "min-w-60 rounded-lg bg-white drop-shadow-m",
      "absolute right-0 top-full z-10 mt-4",
      "divide-y divide-solid divide-grey-02"
    ]),
    ...t,
    children: e
  }
), nr = x([
  "flex h-12 items-center w-full rounded px-3 text-left",
  "hover:bg-grey-01 active:bg-grey-transparent-02"
]), Ja = ({
  renderKey: e,
  children: t,
  className: r,
  ...n
}) => /* @__PURE__ */ o(Le.Item, { as: "div", children: /* @__PURE__ */ o("button", { className: x(nr, r), ...n, children: t }) }, e), Za = ({
  children: e,
  className: t,
  href: r,
  renderKey: n,
  ...l
}) => /* @__PURE__ */ o(Le.Item, { as: "div", children: /* @__PURE__ */ h(
  "a",
  {
    className: x(nr, "justify-between", t),
    href: r,
    ...l,
    children: [
      e,
      /* @__PURE__ */ o(gn, { className: "h-5 w-5 text-grey-05" })
    ]
  }
) }, n), ei = ({
  children: e,
  className: t,
  renderKey: r,
  to: n,
  ...l
}) => /* @__PURE__ */ o(Le.Item, { as: "div", children: ({ close: i }) => /* @__PURE__ */ o(
  Ie,
  {
    onClick: i,
    className: x(nr, t),
    to: n,
    ...l,
    children: e
  }
) }, r), ti = ({ children: e }) => /* @__PURE__ */ o("div", { className: "p-1", children: e }), ri = ({ className: e, children: t }) => /* @__PURE__ */ o(Le.Item, { className: x("px-4 py-3", e), as: "div", children: t });
pe.Actions = ti;
pe.Button = Ja;
pe.Content = Ya;
pe.ExternalLink = Za;
pe.Link = ei;
pe.Section = ri;
pe.Trigger = Qa;
const ds = ({
  chapters: e,
  duration: t,
  imageAlt: r,
  imageSrc: n,
  lable: l,
  progress: i = 0,
  showDetails: a = !1,
  showProgress: s = !0,
  subtitle: c,
  title: u,
  to: p
}) => /* @__PURE__ */ o(me, { className: "group", children: /* @__PURE__ */ h(Ie, { className: "text-grey-08", to: p, children: [
  /* @__PURE__ */ h(
    "div",
    {
      className: x([
        "relative flex justify-center overflow-hidden rounded-lg bg-grey-02",
        a ? "mb-3" : "mb-2"
      ]),
      children: [
        /* @__PURE__ */ o(
          "img",
          {
            alt: r,
            src: n,
            className: "h-[140px] w-full rounded-lg object-cover transition-transform duration-500 group-hover:scale-105	"
          }
        ),
        l && /* @__PURE__ */ o("div", { className: "absolute top-1 left-2 ", children: /* @__PURE__ */ o(_e, { title: l, variant: "primary" }) })
      ]
    }
  ),
  s && /* @__PURE__ */ h("div", { className: "mb-1 flex items-center", children: [
    /* @__PURE__ */ o("div", { className: "h-1 w-full rounded-lg bg-grey-02", children: /* @__PURE__ */ o(
      "div",
      {
        "aria-label": `${i}%`,
        className: "h-1 rounded-lg bg-secondary-04",
        style: { width: `${i}%` }
      }
    ) }),
    /* @__PURE__ */ h("span", { className: "ml-3 text-xs text-grey-06", children: [
      i,
      "%"
    ] })
  ] }),
  /* @__PURE__ */ o(me.Title, { bottomMargin: "xs", children: u }),
  /* @__PURE__ */ o(me.Body, { className: "mb-2 text-grey-05 line-clamp-2", children: c }),
  a && /* @__PURE__ */ h("div", { className: "flex items-center gap-4", children: [
    e !== void 0 && /* @__PURE__ */ h("span", { className: "text-sm text-grey-04", children: [
      /* @__PURE__ */ o(gr, { className: "inline h-4 w-4" }),
      " ",
      e
    ] }),
    !!t && /* @__PURE__ */ h("span", { className: "text-sm text-grey-04", children: [
      /* @__PURE__ */ o(hr, { className: "inline h-4 w-4" }),
      " ",
      t
    ] })
  ] })
] }) }), lr = ({
  id: e,
  children: t
}) => /* @__PURE__ */ h(
  "span",
  {
    role: "alert",
    id: e,
    className: "mt-1 flex h-5 items-center text-sm text-error-04",
    children: [
      /* @__PURE__ */ o(hn, { className: "mr-2 inline h-5 w-5" }),
      t
    ]
  }
), ps = ({
  children: e,
  feedbackLabel: t,
  userImg: r,
  userName: n,
  userId: l
}) => /* @__PURE__ */ h("div", { className: "w-auto rounded-lg bg-grey-transparent-01 py-3 px-4", children: [
  /* @__PURE__ */ o("div", { className: "mb-2 text-2xs uppercase text-grey-05", children: t }),
  n && l && /* @__PURE__ */ h("div", { className: "mb-3 flex items-center", children: [
    /* @__PURE__ */ o(Dt, { imageSrc: r, name: n, id: l, inline: !0 }),
    /* @__PURE__ */ o("span", { className: "text-sm-medium", children: n })
  ] }),
  /* @__PURE__ */ o("p", { className: "text-sm-multiline text-grey-08", children: e })
] }), ni = {
  md: "text-sm-medium px-2 py-1",
  sm: "text-xs-medium px-2 py-1"
}, li = ({
  active: e,
  counter: t,
  children: r,
  disabled: n = !1,
  disclosure: l = !1,
  openDisclosureLabel: i,
  removeDisclosureLabel: a,
  onClick: s,
  size: c = "md"
}) => /* @__PURE__ */ h(
  "button",
  {
    "aria-pressed": e,
    className: x([
      "flex items-center rounded-md transition-colors",
      e ? "bg-secondary-04 text-white enabled:hover:bg-secondary-05" : "bg-grey-02 enabled:hover:bg-grey-03 enabled:active:bg-grey-04 ",
      "disabled:bg-grey-02 disabled:text-grey-04",
      ni[c]
    ]),
    disabled: n,
    onClick: s,
    children: [
      r,
      l && e && /* @__PURE__ */ o(
        rt,
        {
          "aria-label": a,
          className: "ml-1 inline h-4 w-4"
        }
      ),
      l && !e && /* @__PURE__ */ o(
        He,
        {
          "aria-label": i,
          className: "ml-1 inline h-3 w-3"
        }
      ),
      t && /* @__PURE__ */ o(
        "span",
        {
          className: Ne(
            x([
              "ml-1",
              e ? "text-secondary-02" : "text-grey-05 active:text-grey-07",
              n && "text-grey-03"
            ])
          ),
          children: t
        }
      )
    ]
  }
), ms = ({
  filters: e,
  label: t,
  onSelect: r,
  selected: n
}) => {
  const l = (a) => n.map(({ value: s }) => s).includes(a.value), i = (a) => {
    l(a) ? r([...n.filter(({ value: s }) => s !== a.value)]) : r([...n, a]);
  };
  return /* @__PURE__ */ h("div", { children: [
    t && /* @__PURE__ */ o("div", { className: "text-sm-medium mb-2", children: t }),
    /* @__PURE__ */ o("div", { className: "flex flex-wrap gap-2", children: e.map((a) => /* @__PURE__ */ o(
      li,
      {
        active: l(a),
        onClick: () => i(a),
        children: a.label
      },
      a.value
    )) })
  ] });
}, je = ({
  Icon: e,
  className: t = "",
  customStyles: r = "",
  inputClassName: n = "",
  disabled: l,
  hasError: i,
  iconPosition: a = "left",
  innerRef: s,
  placeholder: c,
  prefix: u,
  type: p = "text",
  suffix: d,
  textAlign: m = "left",
  ...f
}) => /* @__PURE__ */ h("div", { className: x(["relative", t]), children: [
  /* @__PURE__ */ o(
    "input",
    {
      "aria-invalid": i,
      className: x([
        Pt({ hasError: i }),
        e ? a === "left" ? "pl-10" : "pr-10" : "",
        d && "pr-6",
        // this should actually be bigger if the suffix text grows, seems difficult to do with css only
        u && (u.length < 4 ? "pl-11" : "pl-12"),
        // this should actually be bigger if the prefix text grows, difficult to do with css only
        m === "center" && "text-center",
        n,
        r
      ]),
      disabled: l,
      placeholder: c || "",
      ref: s,
      type: p,
      ...f
    }
  ),
  !!e && /* @__PURE__ */ o(
    e,
    {
      className: x([
        "absolute h-5 w-5",
        "pointer-events-none",
        "top-2 ",
        a === "left" ? "left-3" : "right-3"
      ])
    }
  ),
  !!d && /* @__PURE__ */ o("span", { className: "pointer-events-none absolute top-2 right-2 text-grey-04", children: d }),
  !!u && /* @__PURE__ */ o("span", { className: "pointer-events-none absolute top-2 left-2 text-grey-04", children: u })
] }), oi = br(
  (e, t) => /* @__PURE__ */ o(je, { Icon: xr, ...e, innerRef: t })
), ai = (e) => ({ name: t }) => t.toLowerCase().includes(e.toLowerCase()), fs = ({
  buttonText: e,
  clearButtonLabel: t,
  dropdownPositionMobileRight: r,
  dropdownProps: n,
  options: l,
  onChange: i,
  searchable: a,
  value: s
}) => {
  const [c, u] = H(""), p = c === "" ? l : l.filter(ai(c)), d = (n == null ? void 0 : n.className) || "";
  return n == null || delete n.className, /* @__PURE__ */ o(q, { value: s, onChange: i, children: ({ open: m }) => /* @__PURE__ */ h(te, { children: [
    /* @__PURE__ */ h(
      q.Button,
      {
        className: x(
          "flex items-center rounded-md py-1 px-2 text-sm",
          s ? "bg-secondary-04 text-white hover:bg-secondary-05" : "bg-grey-02 hover:bg-grey-03 active:bg-grey-04",
          "outline-primary-02 focus:outline focus:outline-4"
        ),
        children: [
          s ? `${e}: ${s.name}` : e,
          s ? /* @__PURE__ */ o(
            "button",
            {
              onClick: (f) => {
                f.preventDefault(), i == null || i(void 0);
              },
              "aria-label": t,
              children: /* @__PURE__ */ o(
                rt,
                {
                  className: x(
                    "ml-2 h-3 w-3",
                    "text-white hover:text-opacity-80"
                  )
                }
              )
            }
          ) : /* @__PURE__ */ o(te, { children: m ? /* @__PURE__ */ o(et, { className: "ml-2 h-3 w-3" }) : /* @__PURE__ */ o(He, { className: "ml-2 h-3 w-3" }) })
        ]
      }
    ),
    m && /* @__PURE__ */ o("div", { className: "relative", children: /* @__PURE__ */ o(
      "div",
      {
        className: `absolute ${r && "sm:right-0 md:left-0 "}`,
        children: /* @__PURE__ */ h("div", { className: "mt-2 w-52 rounded-lg bg-white p-2 drop-shadow-s md:w-60 lg:w-72", children: [
          a && /* @__PURE__ */ o(
            q.Input,
            {
              onChange: (f) => u(f.currentTarget.value),
              value: c,
              as: oi
            }
          ),
          /* @__PURE__ */ o(
            q.Options,
            {
              className: x([
                "mt-1 max-h-40 space-y-1 overflow-auto pr-1",
                d
              ]),
              ...n,
              children: p.map((f) => /* @__PURE__ */ o(
                q.Option,
                {
                  as: ae,
                  value: f,
                  children: ({ selected: b }) => /* @__PURE__ */ o(
                    "div",
                    {
                      className: x([
                        "flex items-center rounded px-3 py-2 text-sm",
                        "hover:cursor-pointer hover:bg-grey-01 active:bg-grey-02",
                        b ? "bg-secondary-01" : "bg-transparent"
                      ]),
                      children: f.name
                    }
                  )
                },
                f.id
              ))
            }
          )
        ] })
      }
    ) })
  ] }) });
}, ii = (e) => typeof e == "string" || e instanceof String, si = ({
  disabled: e,
  hasError: t,
  id: r,
  min: n,
  onChange: l,
  value: i,
  variant: a = "date"
}) => {
  const s = (u) => {
    const p = ii(u) ? new Date(u) : u;
    if (p && a === "date") {
      const d = p.getTimezoneOffset();
      return new Date(
        p.getTime() - d * 60 * 1e3
      ).toISOString().split("T")[0];
    } else if (p && a === "datetime-local") {
      const d = p.getTimezoneOffset(), f = new Date(
        p.getTime() - d * 60 * 1e3
      ).toISOString().split("T"), b = f[0], g = f[1].split(".")[0];
      return `${b}T${g}`;
    } else
      return "";
  }, c = (u) => {
    l(u ? new Date(u) : void 0);
  };
  return /* @__PURE__ */ o(
    je,
    {
      disabled: e,
      hasError: t,
      Icon: vn,
      iconPosition: "right",
      id: r,
      min: s(n),
      onChange: (u) => c(u.target.value),
      type: a,
      value: s(i)
    }
  );
}, or = ({
  htmlFor: e,
  children: t
}) => /* @__PURE__ */ o("label", { htmlFor: e, className: "text-sm-semibold mb-1 block", children: t }), ci = ({
  ariaDescribedby: e,
  customStyles: t,
  onChange: r,
  hasError: n,
  disabled: l,
  placeholder: i,
  value: a,
  limit: s,
  readOnly: c = !1,
  prefix: u,
  id: p,
  onBlur: d,
  minRows: m = 3
}) => /* @__PURE__ */ h("div", { className: "flex flex-col gap-1", children: [
  u && /* @__PURE__ */ o("div", { className: "relative", children: /* @__PURE__ */ o("span", { className: "absolute top-3 left-4 whitespace-nowrap text-2xs uppercase text-grey-05", children: u }) }),
  /* @__PURE__ */ o(
    Ln,
    {
      "aria-describedby": e,
      id: p,
      value: a,
      "aria-invalid": n,
      className: Ne(
        x([Pt({ hasError: n, readOnly: c })]),
        "h-auto resize-none py-1.5",
        u && "px-4 pt-8",
        t
      ),
      disabled: l,
      placeholder: i || "",
      onChange: r,
      maxLength: s,
      readOnly: c,
      minRows: m,
      onBlur: d
    }
  ),
  s && /* @__PURE__ */ h("span", { className: "self-end text-sm text-grey-05", children: [
    a.length,
    " / ",
    s
  ] })
] }), ar = ({
  children: e
}) => /* @__PURE__ */ o("form", { children: e }), ui = ({
  disabled: e,
  errorMessage: t,
  hasError: r,
  id: n,
  label: l,
  onChange: i,
  placeholder: a,
  type: s,
  value: c
}) => /* @__PURE__ */ h("div", { className: "min-w-[440px]", children: [
  l && /* @__PURE__ */ o(or, { htmlFor: n, children: l }),
  /* @__PURE__ */ o(
    je,
    {
      "aria-describedby": `error_${n}`,
      disabled: e,
      hasError: r,
      id: n,
      onChange: i,
      placeholder: a,
      type: s,
      value: c
    }
  ),
  t && /* @__PURE__ */ o(lr, { id: `error_${n}`, children: t })
] }), di = ({
  disabled: e,
  errorMessage: t,
  hasError: r,
  id: n,
  label: l,
  onChange: i,
  placeholder: a,
  value: s
}) => /* @__PURE__ */ h("div", { className: "min-w-[440px]", children: [
  l && /* @__PURE__ */ o(or, { htmlFor: n, children: l }),
  /* @__PURE__ */ o(
    ci,
    {
      ariaDescribedby: `error_${n}`,
      disabled: e,
      hasError: r,
      id: n,
      onChange: i,
      placeholder: a,
      value: s
    }
  ),
  t && /* @__PURE__ */ o(lr, { id: `error_${n}`, children: t })
] }), pi = ({
  disabled: e,
  errorMessage: t,
  hasError: r,
  id: n,
  label: l,
  onChange: i,
  value: a
}) => /* @__PURE__ */ h("div", { className: "min-w-[440px]", children: [
  l && /* @__PURE__ */ o(or, { htmlFor: n, children: l }),
  /* @__PURE__ */ o(
    si,
    {
      disabled: e,
      hasError: r,
      id: n,
      onChange: i,
      value: a,
      variant: "date"
    }
  ),
  t && /* @__PURE__ */ o(lr, { id: `error_${n}`, children: t })
] });
ar.Input = ui;
ar.Textarea = di;
ar.DateInput = pi;
const qr = ({ children: e }) => /* @__PURE__ */ o(
  "header",
  {
    className: "flex h-[80px] items-center justify-between border-b border-solid border-grey-02 bg-white p-3",
    children: e
  }
), bs = ({
  navigation: e,
  rightComponent: t,
  searchBar: r,
  imgSrc: n = "TEO_logo.svg"
}) => /* @__PURE__ */ h(qr, { children: [
  /* @__PURE__ */ h("div", { className: "flex items-center justify-start", children: [
    /* @__PURE__ */ o("img", { src: n, className: "mr-14" }),
    /* @__PURE__ */ o("nav", { className: "flex gap-4", children: e })
  ] }),
  r && r,
  /* @__PURE__ */ o("div", { className: "flex items-center gap-4", children: t })
] }), gs = ({ highlighted: e, text: t }) => {
  const r = t.toLowerCase().indexOf(e.toLowerCase()), n = r + e.length;
  return r === -1 ? /* @__PURE__ */ o(te, { children: t }) : /* @__PURE__ */ h(te, { children: [
    t.substring(0, r),
    /* @__PURE__ */ o("span", { className: "bg-primary-02", children: t.substring(r, n) }),
    t.substring(n, t.length)
  ] });
}, hs = ({
  alt: e,
  imgSrc: t,
  leftComponent: r,
  rightComponent: n,
  title: l,
  searchBar: i
}) => /* @__PURE__ */ h(te, { children: [
  /* @__PURE__ */ h(qr, { children: [
    r,
    l ? /* @__PURE__ */ o("span", { className: "flex items-center", children: l }) : /* @__PURE__ */ o("img", { src: t, className: "m-1", alt: e }),
    n
  ] }),
  i && i
] }), pr = 1, mi = 99, St = (e, t, r) => Math.min(t, Math.max(r, e)), vs = ({
  decreaseButtonLabel: e,
  disabled: t,
  increaseButtonLabel: r,
  inputFieldLabel: n,
  maxScore: l = mi,
  minScore: i = pr,
  onChange: a,
  step: s = 1,
  suffix: c,
  value: u
}) => /* @__PURE__ */ h("div", { className: "flex flex-row gap-1", children: [
  /* @__PURE__ */ o(
    ge,
    {
      Icon: xn,
      ariaLabel: e,
      onClick: () => a(St(u - s, l, i)),
      variant: "outline",
      size: "lg",
      disabled: t
    }
  ),
  /* @__PURE__ */ o(
    je,
    {
      "aria-label": n,
      className: `${c ? "w-14" : "w-11"}`,
      onChange: (p) => {
        a(
          p.currentTarget.value ? St(
            Number(p.currentTarget.value),
            l,
            i
          ) : pr
        );
      },
      value: u == null ? void 0 : u.toString(),
      type: "number",
      textAlign: "center",
      suffix: c,
      disabled: t
    }
  ),
  /* @__PURE__ */ o(
    ge,
    {
      Icon: yn,
      ariaLabel: r,
      onClick: () => a(St(u + s, l, i)),
      variant: "outline",
      size: "lg",
      disabled: t
    }
  )
] }), fi = ({
  ariaLabelToggle: e,
  disabled: t,
  onChange: r,
  options: n,
  value: l
}) => /* @__PURE__ */ o(
  ye,
  {
    as: "div",
    className: "absolute right-0 top-2.5",
    disabled: t,
    onChange: r,
    value: l,
    children: ({ open: i }) => /* @__PURE__ */ h(te, { children: [
      /* @__PURE__ */ h(
        ye.Button,
        {
          "aria-label": e,
          className: x(
            "flex items-center pr-3 text-sm text-grey-07",
            "outline-primary-02 focus-visible:outline focus-visible:outline-4"
          ),
          children: [
            l.countryCode,
            i ? /* @__PURE__ */ o(et, { className: "ml-2 h-3 w-3" }) : /* @__PURE__ */ o(He, { className: "ml-2 h-3 w-3" })
          ]
        }
      ),
      /* @__PURE__ */ o(
        tr,
        {
          as: ae,
          leave: "transition-opacity",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ o("div", { className: "relative z-10", children: /* @__PURE__ */ o(ye.Options, { className: "absolute mt-3 flex max-h-48 cursor-pointer flex-col gap-1 overflow-auto rounded-lg bg-white p-1 drop-shadow-s focus:outline-none", children: n.map((a, s) => /* @__PURE__ */ o(
            ye.Option,
            {
              className: ({ active: c }) => x(
                "rounded-md px-3 py-2 text-base text-black",
                c && "bg-grey-transparent-02"
              ),
              value: a,
              children: ({ selected: c }) => /* @__PURE__ */ o(
                "span",
                {
                  className: x("block", c && "font-medium"),
                  children: a.countryCode
                }
              )
            },
            s
          )) }) })
        }
      )
    ] })
  }
), xs = ({
  countryCodes: e,
  disabled: t,
  hasError: r,
  onChange: n,
  placeholder: l,
  selectCountryCodeLabel: i,
  value: a
}) => /* @__PURE__ */ h("div", { className: "relative", children: [
  /* @__PURE__ */ o(
    je,
    {
      disabled: t,
      hasError: r,
      inputClassName: "pr-14",
      onChange: (s) => n({
        ...a,
        phone: s.currentTarget.value
      }),
      placeholder: l,
      prefix: a.country.callingCode,
      type: "tel",
      value: a.phone
    }
  ),
  /* @__PURE__ */ o(
    fi,
    {
      ariaLabelToggle: i,
      disabled: t,
      onChange: (s) => n({ ...a, country: s }),
      options: e,
      value: a.country
    }
  )
] }), ys = ({
  ariaLabelToggle: e = "Toggle Options",
  children: t,
  customButton: r,
  disabled: n = !1,
  hasError: l = !1,
  onChange: i,
  options: a,
  placeholder: s = "Select",
  value: c
}) => /* @__PURE__ */ o(ye, { value: c, onChange: i, disabled: n, children: ({ open: u }) => /* @__PURE__ */ h("div", { children: [
  r ? /* @__PURE__ */ o(ye.Button, { children: r }) : /* @__PURE__ */ h(
    ye.Button,
    {
      "aria-label": e,
      className: x(
        "flex items-center justify-between",
        "rounded-md border border-solid outline outline-2",
        "min-h-10 w-full px-3 text-base",
        {
          "border-error-04 bg-grey-transparent-01 outline-error-01 hover:bg-white": !n && l && !u,
          "border-error-04 bg-white outline-error-01": !n && l && u,
          "border-grey-03 bg-grey-transparent-02 text-grey-04 outline-transparent": n,
          "border-secondary-04 bg-white outline-secondary-01": !n && !l && u,
          "border-transparent bg-grey-transparent-01 text-grey-08 outline-transparent hover:border-grey-transparent-03 hover:bg-white hover:outline-grey-transparent-01 focus:border-secondary-04 focus:bg-white focus:outline-secondary-01": !n && !l && !u
        }
      ),
      children: [
        /* @__PURE__ */ o("span", { className: "mr-2 block truncate", children: c ? t(c) : s }),
        /* @__PURE__ */ o(
          tt,
          {
            className: x(
              "h-5 w-5",
              "transition-transform",
              u && "rotate-180"
            )
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ o(
    tr,
    {
      as: ae,
      leave: "transition-opacity",
      leaveFrom: "opacity-100",
      leaveTo: "opacity-0",
      children: /* @__PURE__ */ o("div", { className: "listbox relative z-10", children: /* @__PURE__ */ o(ye.Options, { className: "absolute mt-1 flex max-h-40 w-full cursor-pointer flex-col gap-1 overflow-auto rounded-lg bg-white p-1 drop-shadow-s focus:outline-none", children: a.map((p, d) => /* @__PURE__ */ o(
        ye.Option,
        {
          className: ({ active: m }) => x(
            "rounded-md px-3 py-2 text-base text-black",
            m && "bg-grey-transparent-02"
          ),
          value: p,
          children: ({ selected: m }) => /* @__PURE__ */ o(
            "span",
            {
              className: x("block", m && "font-medium"),
              children: t(p)
            }
          )
        },
        d
      )) }) })
    }
  )
] }) }), ws = ({
  Icon: e,
  disabled: t = !1,
  hasError: r = !1,
  onChange: n,
  placeholder: l,
  search: i,
  value: a
}) => {
  const [s, c] = H(""), u = s ? i(s) : [];
  return /* @__PURE__ */ o(
    q,
    {
      value: a,
      onChange: n,
      className: "relative",
      as: "div",
      disabled: t,
      children: ({ open: p }) => /* @__PURE__ */ h(te, { children: [
        /* @__PURE__ */ o(
          q.Input,
          {
            placeholder: l,
            className: x(Pt({ hasError: r }), e && "pl-10"),
            displayValue: () => a,
            onChange: (d) => c(d.target.value)
          }
        ),
        !!e && /* @__PURE__ */ o(
          e,
          {
            className: x([
              "absolute h-5 w-5",
              "pointer-events-none",
              "top-2.5 left-3"
            ])
          }
        ),
        p && u.length > 0 && /* @__PURE__ */ o("div", { className: "mt-2 rounded-lg bg-white p-2 drop-shadow-s", children: /* @__PURE__ */ o(q.Options, { className: "mt-1 max-h-40 space-y-1 overflow-auto pr-1", children: u.map((d) => /* @__PURE__ */ o(q.Option, { value: d, as: ae, children: ({ active: m }) => /* @__PURE__ */ o(
          "div",
          {
            className: Ne(
              x([
                "flex items-center rounded px-3 py-2 text-sm",
                "hover:cursor-pointer hover:bg-grey-01 active:bg-grey-02",
                m ? "bg-grey-01" : "bg-transparent"
              ])
            ),
            children: d
          }
        ) }, d)) }) })
      ] })
    }
  );
}, bi = (e) => ({ label: t }) => t.toLowerCase().includes(e.toLowerCase()), Ns = ({
  customStyles: e,
  disabled: t,
  displayValue: r,
  hasError: n,
  options: l,
  query: i,
  removeButtonLabel: a,
  onChange: s,
  onCommitQuery: c,
  onRemoved: u,
  placeholder: p,
  positionDropdown: d = "bottom",
  toggleSelectionLabel: m,
  value: f,
  setQuery: b
}) => {
  const [g, y] = H(""), [w, v] = H(!1), M = g === "" ? l : l.filter(bi(g)), R = (I) => {
    u ? u == null || u([
      ...(f || []).filter((N) => N.key !== I.key)
    ]) : s == null || s([
      ...(f || []).filter((N) => N.key !== I.key)
    ]);
  }, E = new Set(f == null ? void 0 : f.map((I) => I.key));
  return /* @__PURE__ */ o(q, { disabled: t, multiple: !0, onChange: s, value: f, children: ({ open: I }) => /* @__PURE__ */ h(te, { children: [
    /* @__PURE__ */ h(
      "div",
      {
        "data-testid": "multiselect-wrapper",
        className: x(
          "flex items-center justify-between",
          "rounded-md border border-solid outline outline-2",
          "min-h-10 w-full px-3 text-base",
          {
            "border-error-04 bg-grey-transparent-01 outline-error-01 hover:bg-white": !t && n && !I,
            "border-error-04 bg-white outline-error-01": !t && n && I,
            "border-grey-03 bg-grey-transparent-02 text-grey-04 outline-transparent": t,
            "border-secondary-04 bg-white outline-secondary-01": !t && !n && I,
            "border-transparent bg-grey-transparent-01 text-grey-08 outline-transparent hover:border-grey-transparent-03 hover:bg-white hover:outline-grey-transparent-01 focus:border-secondary-04 focus:bg-white focus:outline-secondary-01": !t && !n && !I
          }
        ),
        children: [
          /* @__PURE__ */ h("div", { className: "flex w-full flex-wrap items-center", children: [
            f == null ? void 0 : f.map((N) => /* @__PURE__ */ o("div", { className: "my-1 mr-2", children: /* @__PURE__ */ o(
              _e,
              {
                disabled: t,
                size: "md",
                onRemove: () => R(N),
                removeButtonLabel: a,
                title: r ? r(N) : N.label
              }
            ) }, N.key)),
            /* @__PURE__ */ o(
              q.Input,
              {
                value: i,
                className: "my-1 flex-1 border-0 bg-transparent p-0 text-sm text-grey-08 !ring-0 placeholder:text-grey-04",
                onBlur: () => v(!1),
                onChange: (N) => b ? b(N.currentTarget.value) : y(N.currentTarget.value),
                onKeyDown: (N) => {
                  (N.key === "Enter" || N.key === "," || N.key === ";") && i && ((N.key === "," || N.key === ";") && setTimeout(() => {
                    b == null || b("");
                  }, 0), c == null || c(i));
                },
                onFocus: () => v(!0),
                placeholder: p
              }
            )
          ] }),
          /* @__PURE__ */ o(
            q.Button,
            {
              "aria-label": m,
              className: "text-grey-07",
              children: /* @__PURE__ */ o(
                tt,
                {
                  className: x(
                    "h-5 w-5",
                    "transition-transform",
                    I && "rotate-180"
                  )
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ o("div", { className: "relative", children: /* @__PURE__ */ o(
      q.Options,
      {
        className: `absolute mt-1 max-h-40 w-full overflow-auto rounded-lg bg-white py-1 drop-shadow-s ${d === "top" ? "bottom-9" : "top-0"}`,
        children: M.map((N) => /* @__PURE__ */ o(
          q.Option,
          {
            className: x([
              "relative flex w-full items-center",
              "px-4 py-3",
              "cursor-default hover:cursor-pointer"
            ]),
            value: N,
            children: () => /* @__PURE__ */ h(te, { children: [
              /* @__PURE__ */ o("span", { children: E.has(N.key) ? /* @__PURE__ */ o(wn, { className: "h-5 w-5 fill-secondary-04" }) : /* @__PURE__ */ o(Nn, { className: "h-5 w-5 stroke-grey-06" }) }),
              /* @__PURE__ */ o("span", { className: "flex-1 pl-2 text-sm text-black", children: N.label })
            ] })
          },
          N.key
        ))
      }
    ) })
  ] }) });
}, gi = (e) => ({ label: t }) => t.toLowerCase().includes(e.toLowerCase()), Ss = ({
  addTagLabel: e,
  customStyles: t,
  disabled: r,
  handleAddTag: n,
  hasError: l,
  options: i,
  query: a,
  removeButtonLabel: s,
  onChange: c,
  onCommitQuery: u,
  onRemoved: p,
  placeholder: d,
  positionDropdown: m = "bottom",
  toggleSelectionLabel: f,
  value: b,
  setQuery: g
}) => {
  const [y, w] = H(""), [v, M] = H(!1), R = y === "" ? i : i.filter(gi(y)), E = (I) => {
    p ? p == null || p([
      ...(b || []).filter((N) => N.key !== I.key)
    ]) : c == null || c([
      ...(b || []).filter((N) => N.key !== I.key)
    ]);
  };
  return /* @__PURE__ */ o(q, { disabled: r, multiple: !0, onChange: c, value: b, children: ({ open: I }) => /* @__PURE__ */ h(te, { children: [
    /* @__PURE__ */ h(
      "div",
      {
        "data-testid": "multiselect-wrapper",
        className: x(
          "flex items-center justify-between",
          "rounded-md border border-solid outline outline-2",
          "min-h-10 w-full px-3 text-base",
          {
            "border-error-04 bg-grey-transparent-01 outline-error-01 hover:bg-white": !r && l && !I,
            "border-error-04 bg-white outline-error-01": !r && l && I,
            "border-grey-03 bg-grey-transparent-02 text-grey-04 outline-transparent": r,
            "border-secondary-04 bg-white outline-secondary-01": !r && !l && I,
            "border-transparent bg-grey-transparent-01 text-grey-08 outline-transparent hover:border-grey-transparent-03 hover:bg-white hover:outline-grey-transparent-01 focus:border-secondary-04 focus:bg-white focus:outline-secondary-01": !r && !l && !I
          }
        ),
        children: [
          /* @__PURE__ */ h("div", { className: "flex w-full flex-wrap items-center", children: [
            b == null ? void 0 : b.map((N) => /* @__PURE__ */ o("div", { className: "my-1 mr-2", children: /* @__PURE__ */ o(
              _e,
              {
                disabled: r,
                size: "md",
                onRemove: () => E(N),
                removeButtonLabel: s,
                title: N.label
              }
            ) }, N.key)),
            /* @__PURE__ */ o(
              q.Input,
              {
                value: a,
                className: "my-1 flex-1 border-0 bg-transparent p-0 text-sm text-grey-08 !ring-0 placeholder:text-grey-04",
                onBlur: () => M(!1),
                onChange: (N) => g ? g(N.currentTarget.value) : w(N.currentTarget.value),
                onKeyDown: (N) => {
                  (N.key === "Enter" || N.key === "," || N.key === ";") && a && ((N.key === "," || N.key === ";") && setTimeout(() => {
                    g == null || g("");
                  }, 0), u == null || u(a));
                },
                onFocus: () => M(!0),
                placeholder: d
              }
            )
          ] }),
          /* @__PURE__ */ o(
            q.Button,
            {
              "aria-label": f,
              className: "text-grey-07",
              children: /* @__PURE__ */ o(
                tt,
                {
                  className: x(
                    "h-5 w-5",
                    "transition-transform",
                    I && "rotate-180"
                  )
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ o("div", { className: "relative", children: /* @__PURE__ */ h(
      q.Options,
      {
        className: `absolute mt-1 max-h-40 w-full overflow-auto rounded-lg bg-white py-1 drop-shadow-s ${m === "top" ? "bottom-9" : "top-0"}`,
        children: [
          R.map((N) => /* @__PURE__ */ o(
            q.Option,
            {
              className: x([
                "relative flex w-full items-center",
                "px-4 py-3",
                "cursor-default hover:cursor-pointer"
              ]),
              value: N,
              children: () => /* @__PURE__ */ h(te, { children: [
                /* @__PURE__ */ o(Sn, { className: "h-[17.5px] w-[17.5px] text-[#6d6d72]" }),
                /* @__PURE__ */ o("span", { className: "flex-1 pl-2 text-sm text-black", children: N.label })
              ] })
            },
            N.key
          )),
          /* @__PURE__ */ o(
            "div",
            {
              className: x([
                "relative flex w-full items-center",
                "cursor-default hover:cursor-pointer"
              ]),
              children: /* @__PURE__ */ h(
                Oe,
                {
                  variant: "ghost",
                  onClick: n,
                  className: "m-0 flex items-center p-0",
                  children: [
                    /* @__PURE__ */ o(On, { className: "mr-2 h-[12.92px] w-[12.92px] text-sm font-normal text-[#231f20]" }),
                    e
                  ]
                }
              )
            }
          )
        ]
      }
    ) })
  ] }) });
}, Os = ({ children: e }) => /* @__PURE__ */ o("nav", { className: "space-y-2", children: e }), Ts = ({
  Icon: e,
  children: t,
  iconOnly: r,
  to: n,
  end: l
}) => {
  const i = Array.isArray(n) ? n : [n], a = $n(), { pathname: s } = a, c = s.slice(
    s.lastIndexOf("/") + 1,
    s.indexOf("?")
  ), p = i.map(
    (d) => d.slice(d.lastIndexOf("/") + 1, d.indexOf("?"))
  ).includes(c);
  return /* @__PURE__ */ o(
    Ie,
    {
      className: x([
        "flex rounded-lg px-4 py-3",
        "font-medium text-grey-09",
        "hover:bg-grey-01",
        p && "bg-grey-01"
      ]),
      to: i[0],
      children: /* @__PURE__ */ h(te, { children: [
        !!e && /* @__PURE__ */ o(
          e,
          {
            isPrimary: p,
            className: x(["h-6 w-6", r || "mr-4"])
          }
        ),
        !r && t
      ] })
    }
  );
}, hi = ({
  children: e
}) => /* @__PURE__ */ o(Pn, { children: /* @__PURE__ */ o("div", { className: "flex flex-col gap-3", children: e }) }), vi = ({
  ActionIcon: e,
  Icon: t,
  actionClassName: r = "bg-success-04",
  actionLabel: n,
  avatarId: l,
  avatarImage: i,
  avatarName: a,
  clickLabel: s,
  disabled: c = !1,
  iconClassName: u,
  iconLabel: p,
  isRead: d = !1,
  onAction: m,
  onClick: f,
  subtitle: b,
  title: g,
  type: y
}) => {
  const w = Ze(), v = (I) => /* @__PURE__ */ o(_n, { onClick: m, Tag: "button", children: /* @__PURE__ */ o(
    "div",
    {
      className: x([
        "flex items-center px-8",
        I ? "rounded-l-lg" : "rounded-r-lg",
        r
      ]),
      children: /* @__PURE__ */ o(e, { className: "h-6 w-6 text-white" })
    }
  ) }), M = () => /* @__PURE__ */ o(An, { children: v(!0) }), R = () => /* @__PURE__ */ o(Mn, { children: v(!1) });
  let E = null;
  return y === "icon" && t ? E = /* @__PURE__ */ o(
    t,
    {
      "aria-label": p,
      className: x(["h-8 w-8", u])
    }
  ) : l && a && (y === "team" ? E = /* @__PURE__ */ o(jn, { id: l, name: a }) : y === "person" && (E = /* @__PURE__ */ o(Dt, { id: l, name: a, imageSrc: i }))), /* @__PURE__ */ o(
    Fn,
    {
      blockSwipe: c || !w,
      leadingActions: M(),
      trailingActions: R(),
      listType: Dn.IOS,
      children: /* @__PURE__ */ h("div", { className: "relative w-full", children: [
        /* @__PURE__ */ h(
          "button",
          {
            "aria-label": s,
            className: x([
              "flex w-full items-start rounded-lg p-3 text-left",
              d || c ? "bg-white" : "bg-grey-01",
              !c && "cursor-pointer",
              !w && "pr-14"
            ]),
            onClick: f,
            children: [
              /* @__PURE__ */ o("div", { className: "mr-3", children: E }),
              /* @__PURE__ */ h("div", { className: "flex-1", children: [
                /* @__PURE__ */ o("p", { className: "text-xs-multiline text-black", children: g }),
                /* @__PURE__ */ o("p", { className: "mt-1 text-2xs text-grey-07", children: b })
              ] })
            ]
          }
        ),
        !w && /* @__PURE__ */ o(
          ge,
          {
            ariaLabel: n,
            className: `absolute top-3 right-3 ${r}`,
            size: "sm",
            Icon: e,
            onClick: m,
            variant: "outline"
          }
        )
      ] })
    }
  );
};
hi.Item = vi;
const Is = ({
  ariaLabel: e,
  to: t,
  children: r
}) => /* @__PURE__ */ h("div", { className: "flex min-h-12 items-center", children: [
  /* @__PURE__ */ o(
    Kr,
    {
      Icon: vr,
      ariaLabel: e,
      to: t,
      size: "md",
      variant: "ghost"
    }
  ),
  /* @__PURE__ */ o("div", { className: "ml-2 flex w-full items-center justify-between gap-2", children: r })
] }), ks = ({
  className: e,
  max: t = 100,
  value: r
}) => /* @__PURE__ */ o(
  "progress",
  {
    className: x(["progress-bar", e]),
    value: r,
    max: t,
    children: r
  }
), Cs = ({ children: e, className: t, isChildQuote: r = !1 }) => /* @__PURE__ */ o(
  "blockquote",
  {
    className: Ne(
      x(
        t,
        "text-sm-multiline border-l-2 border-solid pl-4",
        r && "mt-6",
        on(e == null ? void 0 : e.toString())
      )
    ),
    children: Lt(e, { isChildQuote: !0 })
  }
), xi = ({
  children: e,
  className: t,
  disabled: r = !1,
  ...n
}) => /* @__PURE__ */ h(
  "label",
  {
    className: x([
      "flex flex-1 items-center rounded-lg border border-grey-02 bg-white px-4.5 py-3.5",
      !r && "hover:border-grey-04",
      t
    ]),
    children: [
      /* @__PURE__ */ o(Ge, { disabled: r, ...n }),
      e && /* @__PURE__ */ o("div", { className: "ml-5 flex items-center", children: e })
    ]
  }
), yi = ({
  children: e,
  className: t,
  value: r
}) => /* @__PURE__ */ o(Se.Option, { value: r, className: t, children: ({ checked: n }) => /* @__PURE__ */ h("div", { className: "flex cursor-pointer items-center gap-2", children: [
  /* @__PURE__ */ o(Ge, { checked: n, id: r, children: ({ className: l }) => /* @__PURE__ */ o("span", { className: l }) }),
  /* @__PURE__ */ o("span", { className: "cursor-pointer", children: e })
] }) }), wi = ({
  children: e,
  className: t,
  value: r
}) => /* @__PURE__ */ o(Se.Option, { value: r, className: t, children: ({ checked: n }) => /* @__PURE__ */ o("div", { className: "flex cursor-pointer items-center gap-2", children: /* @__PURE__ */ o(xi, { checked: n, id: r, children: /* @__PURE__ */ o("span", { className: "cursor-pointer", children: e }) }) }) }), Wr = ({ children: e, onChange: t, value: r, label: n, gap: l }) => /* @__PURE__ */ h(
  Se,
  {
    value: r,
    onChange: t,
    className: x("flex flex-col", l || "gap-4"),
    children: [
      /* @__PURE__ */ o("div", { className: "text-sm-semibold", children: n }),
      e
    ]
  }
);
Wr.Option = yi;
Wr.CardOption = wi;
const Ni = ({ children: e, className: t, value: r, hiddenRadio: n, Icon: l, classNameIcon: i }) => /* @__PURE__ */ o(Se.Option, { value: r, children: ({ checked: a }) => /* @__PURE__ */ h(
  "div",
  {
    className: x(
      "flex cursor-pointer items-center gap-3 rounded-lg border border-grey-02 p-3",
      a && "border-secondary-04",
      t
    ),
    children: [
      /* @__PURE__ */ o(
        Ge,
        {
          checked: a,
          id: r,
          className: x(n && "hidden"),
          children: ({ className: s }) => /* @__PURE__ */ o("span", { className: s })
        }
      ),
      l && /* @__PURE__ */ o(l, { className: x("h-6 w-6 min-w-6", i) }),
      /* @__PURE__ */ o("span", { className: "cursor-pointer", children: e })
    ]
  }
) }), Si = ({ children: e, onChange: t, value: r, gap: n }) => /* @__PURE__ */ o(
  Se,
  {
    value: r,
    onChange: t,
    className: x("flex flex-col", n || "gap-4"),
    children: e
  }
);
Si.Option = Ni;
const Oi = ({
  checkedClassName: e,
  children: t,
  className: r,
  value: n,
  hiddenRadio: l,
  Icon: i,
  classNameIcon: a
}) => /* @__PURE__ */ o(Se.Option, { value: n, children: ({ checked: s }) => /* @__PURE__ */ h(
  "div",
  {
    className: x(
      "flex cursor-pointer items-center gap-3 rounded-lg p-3",
      s && e,
      r
    ),
    children: [
      /* @__PURE__ */ o(
        Ge,
        {
          checked: s,
          id: n,
          className: x(l && "hidden"),
          children: ({ className: c }) => /* @__PURE__ */ o("span", { className: c })
        }
      ),
      i && /* @__PURE__ */ o(i, { className: x("h-6 w-6 min-w-6", a) }),
      /* @__PURE__ */ o("span", { className: "cursor-pointer", children: t })
    ]
  }
) }), Ti = ({
  children: e,
  onChange: t,
  value: r,
  gap: n,
  classBody: l
}) => /* @__PURE__ */ o(
  Se,
  {
    value: r,
    onChange: t,
    className: x(
      "flex flex-row rounded-lg p-1",
      n || "gap-0",
      l
    ),
    children: e
  }
);
Ti.Option = Oi;
const Rs = ({
  label: e,
  totalScore: t,
  actualScore: r,
  showAs: n = "fraction",
  size: l = "sm"
}) => /* @__PURE__ */ h(
  "span",
  {
    className: x([
      "flex flex-row gap-2",
      "text-secondary-04",
      l === "xs" ? "text-xs" : "text-sm"
    ]),
    children: [
      e,
      ":",
      ["percentage", "percentage-and-fraction"].includes(n) && /* @__PURE__ */ h("span", { className: "font-semibold", children: [
        Math.round(r / t * 100),
        "%"
      ] }),
      ["fraction", "percentage-and-fraction"].includes(n) && /* @__PURE__ */ h("span", { className: "font-semibold", children: [
        r,
        "/",
        t
      ] })
    ]
  }
), Ii = ({ ariaLabel: e, className: t }) => /* @__PURE__ */ o(
  "div",
  {
    "aria-label": e,
    className: x([
      "h-4 w-4 animate-spin rounded-full border border-b-0 border-r-0 border-solid ease-linear",
      t
    ])
  }
), ki = ({
  backdropLabel: e,
  children: t,
  clearLabel: r,
  loading: n = !1,
  loadingLabel: l,
  onChange: i,
  placeholder: a,
  value: s
}) => {
  const [c, u] = H(!1), p = Re((d) => {
    d.key === "Escape" && u(!1);
  }, []);
  return U(() => (document.addEventListener("keydown", p, !1), () => {
    document.removeEventListener("keydown", p, !1);
  }), [p]), /* @__PURE__ */ h(
    "div",
    {
      className: x([
        c && "fixed left-0 top-0 z-10 flex h-screen w-screen justify-center pt-24 md:bg-grey-transparent-04 md:pt-3 md:pb-32 md:backdrop-blur"
      ]),
      children: [
        c && /* @__PURE__ */ o(
          "button",
          {
            "aria-label": e,
            className: "fixed top-0 h-full w-full cursor-default",
            onClick: () => u(!1)
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            className: x([
              c && "relative z-10 flex max-h-full w-full max-w-[708px] flex-col overflow-hidden bg-white md:h-fit md:rounded-xl"
            ]),
            children: [
              /* @__PURE__ */ h("div", { className: x(["relative", c && "py-3 px-5 md:p-1.5"]), children: [
                /* @__PURE__ */ o(
                  xr,
                  {
                    className: x([
                      "absolute h-5 w-5 md:h-6 md:w-6",
                      "pointer-events-none",
                      c ? "top-5.5 left-8 md:top-4 md:left-6" : "top-2.5 left-3.5 md:top-3 md:left-4.5"
                    ])
                  }
                ),
                /* @__PURE__ */ o(
                  "input",
                  {
                    className: x([
                      "rounded-md border border-solid",
                      "h-10 w-full px-10 py-0 md:h-12 md:px-14",
                      "truncate text-base text-grey-08 placeholder:text-grey-04",
                      "!shadow-none outline outline-2 !outline-offset-0 !ring-0",
                      "border-transparent bg-grey-transparent-01 outline-transparent",
                      "hover:bg-grey-transparent-02",
                      "focus:border-secondary-04 focus:outline-secondary-01",
                      "active:border-secondary-04 active:outline-secondary-01",
                      "transition-colors"
                    ]),
                    onChange: (d) => i(d.target.value),
                    onClick: () => u(!0),
                    onKeyDown: (d) => {
                      d.key === "Escape" ? d.currentTarget.blur() : d.key !== "Tab" && !c && u(!0);
                    },
                    placeholder: a || "",
                    type: "text",
                    value: s
                  }
                ),
                n && /* @__PURE__ */ o(
                  Ii,
                  {
                    ariaLabel: l,
                    className: x([
                      "absolute",
                      c ? "top-6 right-8 md:top-5 md:right-6" : "top-3 right-3 md:top-4 md:right-5"
                    ])
                  }
                ),
                !!(s != null && s.length) && !n && /* @__PURE__ */ o(
                  ge,
                  {
                    ariaLabel: r,
                    className: x([
                      "absolute",
                      c ? "top-3.5 right-7 md:top-3 md:right-4" : "top-0.5 right-2 md:top-1.5 md:right-2"
                    ]),
                    Icon: rt,
                    onClick: () => i(""),
                    variant: "ghost"
                  }
                )
              ] }),
              /* @__PURE__ */ o(
                "div",
                {
                  className: x([
                    "overflow-y-scroll",
                    "transition-opacity",
                    c ? "opacity-100" : "opacity-0"
                  ]),
                  children: c && /* @__PURE__ */ o(te, { children: typeof t == "function" ? t({ close: () => u(!1) }) : t })
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Ci = ({
  children: e,
  title: t
}) => /* @__PURE__ */ h("div", { className: "border-grey-02 px-5 py-3 md:px-4 md:py-4 md:[&:not(:last-child)]:border-b", children: [
  !!t && /* @__PURE__ */ o("p", { className: "mb-3 text-sm", children: t }),
  e
] });
ki.Section = Ci;
const mr = "#EAEAED", Ot = "#C2CDFE", fr = "#7089FD", Es = ({
  id: e = "slider",
  label: t,
  max: r,
  min: n,
  onSlide: l,
  step: i,
  value: a,
  withInput: s
}) => {
  const [c, u] = H(Ot), p = ((a || 0) - (n || 0)) / ((r || 0) - (n || 0)) * 100;
  return /* @__PURE__ */ h("div", { className: "flex items-center gap-6", children: [
    t && /* @__PURE__ */ o("label", { htmlFor: e, className: "text-sm", children: t }),
    /* @__PURE__ */ o(
      "input",
      {
        className: "slider flex-shrink",
        id: e,
        max: r,
        min: n,
        onChange: (d) => {
          l == null || l(parseFloat(d.target.value));
        },
        onMouseDown: () => u(fr),
        onMouseUp: () => u(Ot),
        onTouchEnd: () => u(Ot),
        onTouchStart: () => u(fr),
        step: i,
        style: {
          background: `linear-gradient(to right, ${c} 0%, ${c} ${p}%, ${mr} ${p}%, ${mr})`
        },
        value: a,
        type: "range"
      }
    ),
    s && /* @__PURE__ */ o(
      je,
      {
        type: "number",
        value: a,
        onChange: (d) => l(Number(d == null ? void 0 : d.currentTarget.value)),
        suffix: "%",
        className: "w-[65px]"
      }
    )
  ] });
}, $s = ({
  amount: e,
  changeDirection: t,
  change: r,
  decreasingLabel: n,
  increasingLabel: l,
  label: i,
  unit: a
}) => {
  const s = r == null ? void 0 : r.Icon;
  return /* @__PURE__ */ h("div", { className: "flex flex-col", children: [
    r && /* @__PURE__ */ h(
      "span",
      {
        className: x(
          "mb-2 flex items-center text-xs leading-5",
          r.direction === "increasing" ? "text-success-05" : "text-error-04"
        ),
        children: [
          s && /* @__PURE__ */ o(s, { className: "h-3 w-3 " }),
          r.amount
        ]
      }
    ),
    t && (t === "increasing" ? /* @__PURE__ */ o(Tn, { className: "mb-1", "aria-label": l }) : /* @__PURE__ */ o(In, { className: "mb-1", "aria-label": n })),
    /* @__PURE__ */ h("span", { className: "text-base-semibold mb-1", children: [
      e,
      " ",
      a
    ] }),
    /* @__PURE__ */ o("span", { className: "text-xs text-grey-06", children: i })
  ] });
}, Ri = ({
  children: e
}) => /* @__PURE__ */ o("div", { className: "flex w-full justify-center border-b border-grey-02 bg-grey-01 py-4.5 px-8", children: /* @__PURE__ */ o("ul", { className: "flex gap-10", children: e }) }), Ei = ({
  children: e,
  isActive: t = !1,
  isDone: r = !1,
  onClick: n,
  step: l
}) => /* @__PURE__ */ o("li", { children: /* @__PURE__ */ h(
  "button",
  {
    className: x(
      "text-sm-semibold text-black",
      "flex items-center rounded-md py-1.5 pl-2 pr-2.5",
      "transition-colors hover:bg-grey-transparent-01"
    ),
    onClick: n,
    type: "button",
    children: [
      /* @__PURE__ */ o(
        "span",
        {
          className: x(
            "mr-2 flex h-8 w-8 min-w-8 items-center justify-center rounded-full",
            t && "bg-secondary-04 text-white",
            r && "bg-success-04 text-white",
            !t && !r && "bg-grey-transparent-01 text-grey-07 group-hover:bg-grey-transparent-02"
          ),
          children: r ? /* @__PURE__ */ o(yr, { className: "h-5 w-5" }) : l
        }
      ),
      e
    ]
  }
) });
Ri.Item = Ei;
const ke = ({ children: e }) => /* @__PURE__ */ o("table", { className: "w-full table-auto", children: e }), $i = ({ children: e }) => /* @__PURE__ */ o("thead", { children: /* @__PURE__ */ o("tr", { children: e }) }), Li = ({
  align: e = "right",
  children: t,
  colSpan: r,
  onSort: n,
  sortDirection: l
}) => /* @__PURE__ */ o(
  "th",
  {
    "aria-sort": l,
    className: x(
      "text-sm-medium  text-black",
      "px-2 py-2",
      e === "right" ? "text-right" : "text-left"
    ),
    scope: "col",
    colSpan: r,
    children: n ? /* @__PURE__ */ h(
      "button",
      {
        onClick: n,
        className: x(
          "w-max rounded-md py-1 hover:bg-grey-02 active:bg-grey-03",
          e === "right" ? "text-right" : "text-left"
        ),
        children: [
          t,
          /* @__PURE__ */ h("span", { "aria-hidden": !0, children: [
            l === "ascending" && /* @__PURE__ */ o(kn, { className: "ml-0.5 inline-block h-4 w-4" }),
            l === "descending" && /* @__PURE__ */ o(Cn, { className: "ml-0.5 inline-block h-4 w-4" }),
            !l && /* @__PURE__ */ o(Rn, { className: "ml-0.5 inline-block h-4 w-4" })
          ] })
        ]
      }
    ) : /* @__PURE__ */ o("span", { className: "inline-block w-max py-1", children: t })
  }
), Pi = ({ children: e }) => /* @__PURE__ */ o("tbody", { children: e }), Fi = ({
  children: e,
  id: t,
  opaque: r = !1,
  className: n,
  onClick: l
}) => /* @__PURE__ */ o(
  "tr",
  {
    className: x(
      "h-16 text-sm  hover:bg-grey-01",
      r ? "text-grey-05" : "text-black",
      n
    ),
    onClick: l,
    children: e
  },
  t
), Xr = ({
  colSpan: e,
  align: t = "right",
  className: r
}) => ({
  className: x([
    "px-2 py-2",
    t === "right" ? "text-right" : "text-left",
    r
  ]),
  colSpan: e
}), Di = (e) => /* @__PURE__ */ o("td", { ...Xr(e), children: e.children }), Ai = (e) => {
  const { className: t, ...r } = Xr(e);
  return /* @__PURE__ */ o("td", { className: "h-inherit", children: /* @__PURE__ */ o(
    Ie,
    {
      ...r,
      className: x(
        t,
        "table-cell h-inherit align-middle hover:underline"
      ),
      to: e.to,
      children: e.children
    }
  ) });
}, Mi = ({ children: e }) => /* @__PURE__ */ o("div", { className: x("text-xs text-grey-06"), children: e }), _i = ({ src: e }) => /* @__PURE__ */ o("img", { className: "mr-3 inline h-12", src: e });
ke.Header = $i;
ke.HeaderCell = Li;
ke.Body = Pi;
ke.Row = Fi;
ke.Cell = Di;
ke.CellLink = Ai;
ke.CellImage = _i;
ke.CellSubtext = Mi;
function Qr(e = !1) {
  return sn([
    "h-9 inline-flex items-center px-3 rounded-lg transition-colors",
    "focus-visible:outline focus-visible:outline-4 focus-visible:outline-primary-02",
    e ? "bg-grey-02" : "hover:bg-grey-01"
  ]);
}
const ji = ({ children: e, name: t }) => {
  const r = ie(Yr), n = (r == null ? void 0 : r.activeName) === t;
  return /* @__PURE__ */ o("li", { children: /* @__PURE__ */ o(
    "button",
    {
      className: Qr(n),
      onClick: () => {
        var l;
        (l = r == null ? void 0 : r.onChange) == null || l.call(r, t);
      },
      role: "tab",
      children: e
    }
  ) });
}, Bi = ({ children: e, to: t }) => /* @__PURE__ */ o("li", { children: /* @__PURE__ */ o(
  wr,
  {
    className: ({ isActive: r }) => Qr(r),
    role: "tab",
    to: t,
    children: e
  }
) }), Yr = ue(null), Jr = ({
  activeName: e,
  children: t,
  onChange: r
}) => /* @__PURE__ */ o("ul", { className: "flex space-x-3", role: "tablist", children: /* @__PURE__ */ o(Yr.Provider, { value: { activeName: e, onChange: r }, children: t }) });
Jr.TabButton = ji;
Jr.TabLink = Bi;
const Ls = ({
  Icon: e,
  actionButtonLabel: t,
  avatar: r,
  children: n,
  mainAction: l,
  moreActions: i,
  onResolve: a,
  resolveButtonLabel: s,
  timeStamp: c
}) => /* @__PURE__ */ h("div", { className: "flex flex-col gap-1 text-xs sm:flex-row sm:items-center sm:gap-4", children: [
  /* @__PURE__ */ o(e, { className: "h-6 w-6 flex-none" }),
  /* @__PURE__ */ h("div", { className: "flex items-center gap-4", children: [
    r,
    /* @__PURE__ */ h("div", { className: "flex shrink flex-col", children: [
      /* @__PURE__ */ o("span", { className: "text-sm-multiline mb-0.5", children: n }),
      /* @__PURE__ */ o("span", { className: "text-grey-04", children: c })
    ] })
  ] }),
  /* @__PURE__ */ h("div", { className: "ml-auto flex items-center gap-2", children: [
    l && /* @__PURE__ */ o(Oe, { onClick: l.onAction, variant: "outline", children: l.label }),
    /* @__PURE__ */ o(
      ge,
      {
        Icon: yr,
        variant: "outline",
        onClick: a,
        ariaLabel: s
      }
    ),
    i && /* @__PURE__ */ h(pe, { children: [
      /* @__PURE__ */ o(pe.Trigger, { children: /* @__PURE__ */ o(
        ge,
        {
          variant: "ghost",
          Icon: En,
          ariaLabel: t
        }
      ) }),
      /* @__PURE__ */ o(pe.Content, { children: /* @__PURE__ */ o(pe.Actions, { children: i.map((u) => /* @__PURE__ */ o(pe.Button, { onClick: u.onAction, children: u.label }, u.label)) }) })
    ] })
  ] })
] }), Hi = ({
  title: e,
  children: t,
  selected: r = !1
}) => /* @__PURE__ */ h(
  me,
  {
    className: x([
      "max-w-[260px] rounded-xl px-6 py-5 outline outline-1 outline-grey-02 hover:outline-2 active:outline-grey-04",
      r && "outline-2 outline-secondary-04"
    ]),
    children: [
      /* @__PURE__ */ o(me.Title, { bottomMargin: "lg", children: e }),
      /* @__PURE__ */ o(me.Body, { children: t })
    ]
  }
), Gi = ({ value: e, onChange: t, children: r }) => /* @__PURE__ */ o(Se, { value: e, onChange: t, className: "flex gap-4", children: r }), Vi = ({ value: e, title: t, children: r }) => /* @__PURE__ */ o(
  Se.Option,
  {
    value: e,
    className: "focus:rounded-xl focus:outline-secondary-04",
    children: ({ checked: n }) => /* @__PURE__ */ o(Hi, { title: t, selected: n, children: r })
  }
);
Gi.Option = Vi;
const Ps = () => /* @__PURE__ */ o(an, { pauseOnHover: !0, newestOnTop: !0 });
export {
  nt as Avatar,
  Vn as AvatarStack,
  ts as Banner,
  zn as BreadCrumbs,
  Oe as Button,
  Tt as ButtonLink,
  me as Card,
  rl as Carousel,
  Mt as Checkbox,
  nl as CheckboxCard,
  Tr as CheckboxGroup,
  Or as CheckboxLabel,
  ls as CollapsibleCheckboxCard,
  ns as CollapsibleSwitchCard,
  os as ComboBox,
  es as CompanyAvatar,
  Ur as ContentCard,
  ss as ContentCardLearning,
  as as ContentCardListItem,
  is as ContentCardWithInput,
  cs as CounterTile,
  rr as DefinitionList,
  us as DocumentCard,
  pe as Dropdown,
  ds as EndUserCard,
  lr as ErrorMessage,
  ps as FeedbackCard,
  li as FilterButton,
  fs as FilterDropdown,
  ms as FilterList,
  ar as Form,
  bs as Header,
  qr as HeaderBar,
  gs as Highlight,
  ge as IconButton,
  Kr as IconButtonLink,
  zr as IconTile,
  za as ImagePreview,
  si as InputDate,
  xs as InputPhoneNumber,
  vs as InputScore,
  ys as InputSelect,
  je as InputText,
  ws as InputTextSearch,
  ci as InputTextarea,
  or as Label,
  hs as MobileHeader,
  Pe as Modal,
  Ns as Multiselect,
  Ss as MultiselectWithTags,
  Os as Navigation,
  Ts as NavigationItem,
  hi as Notifications,
  Is as PageHeader,
  qa as Panel,
  Dt as PersonAvatar,
  ks as ProgressBar,
  Cs as Quote,
  Ge as Radio,
  xi as RadioCard,
  Wr as RadioGroup,
  Si as RadioGroupActive,
  Ti as RadioGroupTab,
  Rs as Score,
  ki as SearchBar,
  Es as Slider,
  Ii as Spinner,
  $s as StatsCard,
  Ri as Stepper,
  Na as Switch,
  ke as Table,
  Jr as Tabs,
  _e as Tag,
  Ls as Task,
  jn as TeamAvatar,
  Bn as TextAvatar,
  Hi as TextCard,
  Gi as TextCardSelection,
  As as Toast,
  Ps as ToastContainer
};
//# sourceMappingURL=components.mjs.map
